// // import { useEffect, useState, useMemo, useCallback } from "react";
// // import { IPDCWelcomeMessage } from "../../../components"; //IPDCMessageCard
// // import { GetParcelsInPark,
// //   GetShedsByPark, 
// //   GetRevenueByPark,
// //   GetArrearByPark,
// //   GetInvestorInPark,
// //   GetInvestorsActivityByPark,
// //   GetOccuAvaByPark,
// //   GetLandUseByPark   } from "../../Views/Shared/CommonData/CommonData";
// // import useDecodedUser from "../../../services/hooks/useDecodedUser";
// // import {
// //   ParksBySectorCard,
// //   ParksByOccupancyCard,
// //   HandoverCard,
// //   //the flf are newww
// //   // InvestorActivityReportCard,
// //  } from "../Shared/DashboardCards";
// // import LandUseProportionCard from '../LandInfraDevelopment/Head/DashboardDetail/LandUseProportionCard.jsx';
// // import ShedParcelRatioCard from '../LandInfraDevelopment/Head/DashboardDetail/ShedParcelRatioCard.jsx';

// // import {
// //   Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
// //   Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
// //   FormControl, InputLabel, Select, IconButton, CircularProgress,
// //   ToggleButton, ToggleButtonGroup, Alert
// // } from "@mui/material";
// // import {
// //   Business as BusinessIcon,
// //   TrendingUp as TrendingUpIcon,
// //   TrendingDown as TrendingDownIcon,
// //   WarningAmber as WarningIcon,
// //   Receipt as ReceiptIcon,
// //   AccountBalance as AccountBalanceIcon,
// //   AttachMoney as MoneyIcon,
// //   Assessment as AssessmentIcon,
// //   Search as SearchIcon,
// //   Clear as ClearIcon,
// //   Download as DownloadIcon,
// //   BarChart as BarChartIcon,
// //   PieChart as PieChartIcon,
// //   ShowChart as ShowChartIcon,
// //   People as PeopleIcon,
// //   LocationOn as LocationOnIcon,
// //   CheckCircle as CheckCircleIcon,
// //   Warehouse as WarehouseIcon,
// //   ViewModule as ViewModuleIcon,
// //   Straighten as StraightenIcon,
// //   Home as HomeIcon,
// //   Agriculture as AgricultureIcon,
// //   Map as MapIcon
// // } from "@mui/icons-material";




// // // Green Areas Data
// // const SAMPLE_GREEN_AREAS = [
// //   { park_id: 1, capacity: 15.5 },
// //   { park_id: 2, capacity: 18.0 },
// //   { park_id: 3, capacity: 12.0 },
// //   { park_id: 4, capacity: 10.5 },
// //   { park_id: 5, capacity: 8.0 }
// // ];

// // // Roads Data
// // const SAMPLE_ROADS = [
// //   { park_id: 1, capacity: 22.5 },
// //   { park_id: 2, capacity: 25.0 },
// //   { park_id: 3, capacity: 18.0 },
// //   { park_id: 4, capacity: 15.0 }
// // ];

// // // Land Leased Data
// // const SAMPLE_LAND_LEASED = [
// //   { upin: "BL-001", parcel_state: "Occupied" },
// //   { upin: "BL-002", parcel_state: "Occupied" },
// //   { upin: "HW-001", parcel_state: "Occupied" },
// //   { upin: "HW-002", parcel_state: "Occupied" },
// //   { upin: "AD-001", parcel_state: "Occupied" },
// //   { upin: "KL-001", parcel_state: "Occupied" }
// // ];

// // // Revenue Data
// // const SAMPLE_REVENUE = [
// //   { park_name: "Bole Lemi", amount: 2500000, payment_mode: "USD", month: "01", year: "2024" },
// //   { park_name: "Bole Lemi", amount: 1800000, payment_mode: "USD", month: "02", year: "2024" },
// //   { park_name: "Hawassa", amount: 3200000, payment_mode: "USD", month: "01", year: "2024" },
// //   { park_name: "Hawassa", amount: 2800000, payment_mode: "USD", month: "02", year: "2024" },
// //   { park_name: "Adama", amount: 1500000, payment_mode: "Birr", month: "01", year: "2024" },
// //   { park_name: "Kilinto", amount: 1200000, payment_mode: "Birr", month: "01", year: "2024" },
// //   { park_name: "Debre Birhan", amount: 800000, payment_mode: "USD", month: "01", year: "2024" }
// // ];

// // // Arrears Data
// // const SAMPLE_ARREARS = [
// //   { park_name: "Bole Lemi", outstanding: 450000, payment_mode: "USD", overdue_days: 45 },
// //   { park_name: "Hawassa", outstanding: 620000, payment_mode: "USD", overdue_days: 60 },
// //   { park_name: "Adama", outstanding: 280000, payment_mode: "Birr", overdue_days: 30 },
// //   { park_name: "Kilinto", outstanding: 150000, payment_mode: "Birr", overdue_days: 15 }
// // ];

// // // Employment Data
// // const SAMPLE_EMPLOYMENT = [
// //   { park_name: "Bole Lemi", emp_labor_female: 1200, emp_labor_male: 800, emp_prof_female: 150, emp_prof_male: 200, year: "2024" },
// //   { park_name: "Hawassa", emp_labor_female: 2500, emp_labor_male: 1500, emp_prof_female: 200, emp_prof_male: 180, year: "2024" },
// //   { park_name: "Adama", emp_labor_female: 600, emp_labor_male: 500, emp_prof_female: 80, emp_prof_male: 70, year: "2024" },
// //   { park_name: "Kilinto", emp_labor_female: 300, emp_labor_male: 250, emp_prof_female: 60, emp_prof_male: 90, year: "2024" }
// // ];

// // // Trade Data
// // const SAMPLE_TRADE = [
// //   { park_name: "Bole Lemi", export_amount: 4500000, import_amount: 1200000, import_substitution: 500000, year: "2024" },
// //   { park_name: "Hawassa", export_amount: 8500000, import_amount: 2000000, import_substitution: 800000, year: "2024" },
// //   { park_name: "Adama", export_amount: 1800000, import_amount: 600000, import_substitution: 300000, year: "2024" }
// // ];

// // // Investors Data
// // const SAMPLE_INVESTORS = [
// //   { id: 1, company_name: "PVH Ethiopia", capital: 25000000, nationality_origin: "USA", status: "Active", email: "contact@pvh.com", investment_type: "Textile" },
// //   { id: 2, company_name: "TAL Apparel", capital: 18000000, nationality_origin: "Hong Kong", status: "Active", email: "info@tal.com", investment_type: "Garment" },
// //   { id: 3, company_name: "Huajian Group", capital: 35000000, nationality_origin: "China", status: "Active", email: "info@huajian.com", investment_type: "Shoes" },
// //   { id: 4, company_name: "Jay Jay Textile", capital: 12000000, nationality_origin: "India", status: "Active", email: "contact@jayjay.com", investment_type: "Textile" }
// // ];

// // // Potential Investors Data
// // const SAMPLE_POTENTIAL_INVESTORS = [
// //   { email: "contact@nike.com", sector_of_interest: "Apparel", park_interested_in: "Hawassa" },
// //   { email: "info@adidas.com", sector_of_interest: "Apparel", park_interested_in: "Bole Lemi" },
// //   { email: "contact@pvh.com", sector_of_interest: "Textile", park_interested_in: "Bole Lemi" },
// //   { email: "info@h&m.com", sector_of_interest: "Fashion", park_interested_in: "Hawassa" },
// //   { email: "contact@zara.com", sector_of_interest: "Fashion", park_interested_in: "Debre Birhan" }
// // ];

// // // Active Contracts Data
// // const SAMPLE_CONTRACTS = [
// //   { investor: "PVH Ethiopia", park: "Bole Lemi", area: 5.2, start_date: "2020-01-15", end_date: "2030-01-14", status: "Active" },
// //   { investor: "TAL Apparel", park: "Hawassa", area: 6.0, start_date: "2019-06-01", end_date: "2029-05-31", status: "Active" },
// //   { investor: "Huajian Group", park: "Bole Lemi", area: 4.8, start_date: "2021-03-10", end_date: "2031-03-09", status: "Active" }
// // ];

// // // ==================== HELPER FUNCTIONS ====================
// // const toNumber = (value) => {
// //   if (typeof value === 'number' && !isNaN(value)) return value;
// //   if (typeof value === 'string') {
// //     // Remove commas, dollar signs, currency symbols, and spaces
// //     const cleaned = value.replace(/[$,]/g, '').trim();
// //     const num = parseFloat(cleaned);
// //     return isNaN(num) ? 0 : num;
// //   }
// //   return 0;
// // };

// // const formatNumber = (number) => {
// //   const num = toNumber(number);
// //   if (num === 0) return "0";
// //   return new Intl.NumberFormat('en-US').format(num);
// // };

// // const formatCurrency = (amount, paymentMode = "usd") => {
// //   const formatted = formatNumber(amount);
// //   const mode = paymentMode?.toLowerCase() || "usd";
// //   if (mode === "usd") return `$${formatted}`;
// //   return `${formatted} ETB`;
// // };

// // const formatCurrencyUSD = (amount) => `$${formatNumber(amount)}`;
// // const formatCurrencyETB = (amount) => `${formatNumber(amount)} ETB`;
// // const formatPercentage = (value) => {
// //   const num = toNumber(value);
// //   if (num === 0) return "0%";
// //   return `${num.toFixed(1)}%`;
// // };

// // const normalizeCurrency = (paymentMode) => {
// //   if (!paymentMode) return "unknown";
// //   const mode = paymentMode.toLowerCase();
// //   if (mode === "usd" || mode === "USD") return "usd";
// //   if (mode === "birr" || mode === "etb" || mode === "Birr") return "birr";
// //   return mode;
// // };

// // // ==================== PROGRESS BAR COMPONENT ====================
// // const ProgressBarCell = ({ value, label, color }) => {
// //   const percentage = Math.min(100, Math.max(0, toNumber(value)));
// //   const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
// //   return (
// //     <Box sx={{ minWidth: 80 }}>
// //       <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
// //         <Box>
// //           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
// //             <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
// //               {formatPercentage(percentage)}
// //             </Typography>
// //           </Box>
// //           <LinearProgress
// //             variant="determinate"
// //             value={percentage}
// //             sx={{
// //               height: 5, borderRadius: 2.5, backgroundColor: '#e0e0e0',
// //               '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
// //             }}
// //           />
// //         </Box>
// //       </Tooltip>
// //     </Box>
// //   );
// // };

// // // ==================== DONUT CHART COMPONENT ====================
// // const DonutChartComponent = ({ title, data, colors, formatValue, total, sx }) => {
// //   const items = Object.keys(data);
// //   const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
// //   const donutColors = colors || ['#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012'];
  
// //   if (items.length === 0 || totalValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%', ...sx }}>
// //         <Typography variant="body2" color="textSecondary">No data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   let startAngle = 0;
// //   const centerX = 80, centerY = 80, radius = 55;
// //   const svgSize = 180;
  
// //   return (
// //     <Box sx={{ p: 0.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%', ...sx }}>
// //       <Typography variant="subtitle2" sx={{ textAlign: 'center', mb: 1, fontSize: '1.2rem' }}>{title}</Typography>
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
// //         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
// //           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
// //             {items.map((key, index) => {
// //               const value = data[key] || 0;
// //               const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
// //               const angle = (percentage / 100) * 360;
// //               const endAngle = startAngle + angle;
// //               const startRad = (startAngle * Math.PI) / 180;
// //               const endRad = (endAngle * Math.PI) / 180;
// //               const x1 = centerX + radius * Math.cos(startRad);
// //               const y1 = centerY + radius * Math.sin(startRad);
// //               const x2 = centerX + radius * Math.cos(endRad);
// //               const y2 = centerY + radius * Math.sin(endRad);
// //               const largeArcFlag = angle > 180 ? 1 : 0;
// //               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
// //               const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
// //               startAngle = endAngle;
// //               return slice;
// //             })}
// //             <circle cx={centerX} cy={centerY} r="32" fill="white" />
// //             <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
// //             <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
// //           </svg>
// //         </Box>
// //         <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
// //           {items.slice(0, 5).map((key, index) => {
// //             const value = data[key] || 0;
// //             const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
// //             return (
// //               <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
// //                 <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
// //                 <Typography variant="caption" sx={{ fontSize: '0.7rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
// //                 <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{formatValue(value)} ({percentage}%)</Typography>
// //               </Box>
// //             );
// //           })}
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== HORIZONTAL BAR CHART ====================
// // const HorizontalBarChart = ({ title, data, dataKey, color, formatValue, sx }) => {
// //   let processedData = data;
// //   const isFlatFormat = Object.values(data).some(value => typeof value === 'number');
  
// //   if (isFlatFormat) {
// //     processedData = {};
// //     Object.keys(data).forEach(key => {
// //       processedData[key] = { [dataKey]: data[key] };
// //     });
// //   }
  
// //   const items = Object.keys(processedData);
// //   const maxValue = Math.max(...Object.values(processedData).map(d => d[dataKey] || 0), 0);
  
// //   if (items.length === 0 || maxValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
// //         <Typography variant="body2" color="textSecondary">No data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   return (
// //     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
// //       <Typography variant="subtitle2" sx={{ textAlign: 'center', mb: 1.5, fontSize: '1.2rem' }}>{title}</Typography>
// //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
// //         {items.slice(0, 6).map((item) => {
// //           const value = processedData[item][dataKey] || 0;
// //           const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
// //           return (
// //             <Box key={item}>
// //               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
// //                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
// //                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
// //               </Box>
// //               <LinearProgress variant="determinate" value={percentage} sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 } }} />
// //             </Box>
// //           );
// //         })}
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== QUARTERLY REPORT CARD ====================
// // const QuarterlyReportCard = ({ revenueData, arrearsData }) => {
// //   const currentYear = new Date().getFullYear();

// //   const quarters = [
// //     { label: `Q1 ${currentYear}`, months: ["01", "02", "03"] },
// //     { label: `Q2 ${currentYear}`, months: ["04", "05", "06"] },
// //     { label: `Q3 ${currentYear}`, months: ["07", "08", "09"] },
// //     { label: `Q4 ${currentYear}`, months: ["10", "11", "12"] }
// //   ];
 
// //   const quarterData = quarters.map(q => {
// //     // Separate revenue by currency
// //     const revenueUSD = revenueData
// //       .filter(r => q.months.includes(r.month) && 
// //                    String(r.year) === String(currentYear) && 
// //                    (r.payment_mode?.toLowerCase() === "usd" || r.payment_mode?.toLowerCase() === "usd"))
// //       .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
// //     const revenueBirr = revenueData
// //       .filter(r => q.months.includes(r.month) && 
// //                    String(r.year) === String(currentYear) && 
// //                    (r.payment_mode?.toLowerCase() === "birr" || r.payment_mode?.toLowerCase() === "etb"))
// //       .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
// //     const totalRevenue = revenueUSD + revenueBirr;
    
// //     // Separate outstanding by currency
// //     const outstandingUSD = arrearsData
// //       .filter(a => (a.payment_mode?.toLowerCase() === "usd" || a.payment_mode?.toLowerCase() === "usd"))
// //       .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
    
// //     const outstandingBirr = arrearsData
// //       .filter(a => (a.payment_mode?.toLowerCase() === "birr" || a.payment_mode?.toLowerCase() === "etb"))
// //       .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
    
// //     const totalOutstanding = outstandingUSD + outstandingBirr;
   
// //     return { 
// //       label: q.label, 
// //       revenueUSD, 
// //       revenueBirr,
// //       totalRevenue,
// //       outstandingUSD,
// //       outstandingBirr,
// //       totalOutstanding,
// //       collectedUSD: revenueUSD - outstandingUSD,
// //       collectedBirr: revenueBirr - outstandingBirr,
// //       totalCollected: totalRevenue - totalOutstanding
// //     };
// //   });

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Quarterly Report</Typography>
// //       <Box sx={{ overflowX: 'auto' }}>
// //         <Box sx={{ display: 'flex', gap: 2, minWidth: 600 }}>
// //           {quarterData.map((q, idx) => (
// //             <Box key={idx} sx={{ flex: 1, textAlign: 'center', p: 1, bgcolor: 'white', borderRadius: 1 }}>
// //               <Typography variant="body2" fontWeight="bold">{q.label}</Typography>
              
// //               {/* USD Section */}
// //               <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>USD</Typography>
// //               <Typography variant="caption" color="textSecondary">Revenue</Typography>
// //               <Typography variant="body2" color="green">{formatCurrencyUSD(q.revenueUSD)}</Typography>
             
// //               <Typography variant="caption" color="textSecondary">Outstanding</Typography>
// //               <Typography variant="body2" color="red">{formatCurrencyUSD(q.outstandingUSD)}</Typography>
              
// //               <Divider sx={{ my: 1 }} />
              
// //               {/* Birr Section */}
// //               <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>BIRR</Typography>
// //               <Typography variant="caption" color="textSecondary">Revenue</Typography>
// //               <Typography variant="body2" color="green">{formatCurrencyETB(q.revenueBirr)}</Typography>
              
// //               <Typography variant="caption" color="textSecondary">Outstanding</Typography>
// //               <Typography variant="body2" color="red">{formatCurrencyETB(q.outstandingBirr)}</Typography>
              
            
              
              
// //             </Box>
// //           ))}
// //         </Box>
// //       </Box>
// //     </Card>
// //   );
// // };

// // // ==================== INVESTOR SUMMARY CARD ====================
// // const InvestorSummaryCard = ({ investorsData, potentialInvestors }) => {
// //   const activeInvestors = investorsData.filter(i => i.status === "active" || i.status === "Operational").length;
// //   const byNationality = {};
// //   investorsData.forEach(i => {
// //     const country = i.nationality_origin || "Unknown";
// //     byNationality[country] = (byNationality[country] || 0) + 1;
// //   });

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investor Summary</Typography>
// //       <Grid container spacing={1}>
// //         <Grid item xs={6}>
// //           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
// //             <Typography variant="h5" fontWeight="bold" color="#1976d2">{investorsData.length}</Typography>
// //             <Typography variant="caption">Total Investors</Typography>
// //           </Box>
// //         </Grid>
// //         <Grid item xs={6}>
// //           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
// //             <Typography variant="h5" fontWeight="bold" color="#2e7d32">{activeInvestors}</Typography>
// //             <Typography variant="caption">Active Investors</Typography>
// //           </Box>
// //         </Grid>
// //         <Grid item xs={12}>
// //           <Divider sx={{ my: 1 }} />
// //           <Typography variant="body2" fontWeight="bold" gutterBottom>By Nationality:</Typography>
// //           {Object.entries(byNationality).slice(0, 4).map(([country, count]) => (
// //             <Box key={country} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
// //               <Typography variant="caption">{country}</Typography>
// //               <Typography variant="caption" fontWeight="bold">{count}</Typography>
// //             </Box>
// //           ))}
// //         </Grid>
// //       </Grid>
// //     </Card>
// //   );
// // };

// // // ==================== ARREAR REPORT CARD ====================
// // const ArrearReportCard = ({ arrearsData }) => {
// //   const totalOutstanding = arrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
// //   const highRisk = arrearsData.filter(a => a.overdue_days > 90).length;
// //   const mediumRisk = arrearsData.filter(a => a.overdue_days > 30 && a.overdue_days <= 90).length;
// //   const lowRisk = arrearsData.filter(a => a.overdue_days <= 30).length;

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Arrear Report</Typography>
// //       <Box sx={{ textAlign: 'center', mb: 2 }}>
// //         <Typography variant="h4" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
// //         <Typography variant="caption">Total Outstanding</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 2 }}>
// //         <Box sx={{ textAlign: 'center' }}>
// //           <Typography variant="h6" color="#d32f2f">{highRisk}</Typography>
// //           <Typography variant="caption">High Risk (&gt;90 days)</Typography>
// //         </Box>
// //         <Box sx={{ textAlign: 'center' }}>
// //           <Typography variant="h6" color="#ff9800">{mediumRisk}</Typography>
// //           <Typography variant="caption">Medium Risk (30-90 days)</Typography>
// //         </Box>
// //         <Box sx={{ textAlign: 'center' }}>
// //           <Typography variant="h6" color="#4caf50">{lowRisk}</Typography>
// //           <Typography variant="caption">Low Risk (&lt;30 days)</Typography>
// //         </Box>
// //       </Box>
// //     </Card>
// //   );
// // };

// // // ==================== COLLECTED REPORT CARD ====================
// // const CollectedReportCard = ({ revenueData, arrearsData }) => {
// //   const totalInvoiced = revenueData.reduce((sum, r) => sum + toNumber(r.amount), 0);
// //   const totalOutstanding = arrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
// //   const totalCollected = totalInvoiced - totalOutstanding;
// //   const collectionRate = totalInvoiced > 0 ? (totalCollected / totalInvoiced) * 100 : 0;

// //   const usdInvoiced = revenueData.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((sum, r) => sum + toNumber(r.amount), 0);
// //   const usdOutstanding = arrearsData.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((sum, a) => sum + toNumber(a.outstanding), 0);
// //   const usdCollected = usdInvoiced - usdOutstanding;
// //   const usdRate = usdInvoiced > 0 ? (usdCollected / usdInvoiced) * 100 : 0;

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Collected Report</Typography>
      
// //       {/* Collection Rate Gauge */}
// //       <Box sx={{ textAlign: 'center', mb: 2 }}>
// //         <Box sx={{ position: 'relative', display: 'inline-block' }}>
// //           <svg width={180} height={120} viewBox="0 0 180 120">
// //             <path d="M 20 90 A 70 70 0 0 1 160 90" fill="none" stroke="#e0e0e0" strokeWidth="12" strokeLinecap="round" />
// //             <path d={`M 20 90 A 70 70 0 ${collectionRate > 50 ? 1 : 0} 1 ${90 + 70 * Math.cos(Math.PI + (collectionRate * Math.PI) / 180)} ${90 + 70 * Math.sin(Math.PI + (collectionRate * Math.PI) / 180)}`} fill="none" stroke="#4caf50" strokeWidth="12" strokeLinecap="round" />
// //             <text x={90} y={110} textAnchor="middle" fontSize="20" fontWeight="bold" fill="#4caf50">{collectionRate.toFixed(1)}%</text>
// //           </svg>
// //         </Box>
// //         <Typography variant="caption">Overall Collection Rate</Typography>
// //       </Box>

// //       <Divider sx={{ my: 1 }} />

// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
// //         <Typography variant="caption" sx={{ fontWeight: 500 }}>Collected</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#4caf50">{formatCurrencyUSD(totalCollected)}</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
// //         <Typography variant="caption" sx={{ fontWeight: 500 }}>Outstanding</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //         <Typography variant="caption" sx={{ fontWeight: 500 }}>USD Collection Rate</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#1976d2">{usdRate.toFixed(1)}%</Typography>
// //       </Box>
// //     </Card>
// //   );
// // };

// // // ==================== FINANCIAL SUMMARY CARD ====================
// // const FinancialSummaryCard = ({ revenueData, arrearsData, tradeData }) => {
// //   const totalRevenue = revenueData.reduce((sum, r) => sum + toNumber(r.amount), 0);
// //   const totalOutstanding = arrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
// //   const totalExport = tradeData.reduce((sum, t) => sum + toNumber(t.export_amount), 0);
// //   const totalImport = tradeData.reduce((sum, t) => sum + toNumber(t.import_amount), 0);
// //   const netTrade = totalExport - totalImport;

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Financial Summary</Typography>
      
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
// //         <Typography variant="body2">Total Revenue:</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(totalRevenue)}</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
// //         <Typography variant="body2">Total Outstanding:</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
// //       </Box>
// //       <Divider />
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1.5, mb: 1.5 }}>
// //         <Typography variant="body2">Total Export:</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#1976d2">{formatCurrencyUSD(totalExport)}</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
// //         <Typography variant="body2">Total Import:</Typography>
// //         <Typography variant="body2" fontWeight="bold" color="#ff9800">{formatCurrencyUSD(totalImport)}</Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //         <Typography variant="body2">Net Trade Balance:</Typography>
// //         <Typography variant="body2" fontWeight="bold" color={netTrade >= 0 ? "#2e7d32" : "#d32f2f"}>{formatCurrencyUSD(Math.abs(netTrade))} {netTrade >= 0 ? "Surplus" : "Deficit"}</Typography>
// //       </Box>
// //     </Card>
// //   );
// // };

// // // ==================== INVESTMENT BY INDUSTRY CARD ====================
// // const InvestmentByIndustryCard = ({ investorsData }) => {
// //   const byIndustry = {};
// //   investorsData.forEach(i => {
// //     const industry = i.investment_type || "Other";
// //     byIndustry[industry] = (byIndustry[industry] || 0) + 1;
// //   });

// //   const total = investorsData.length;
// //   const colors = ['#1976d2', '#4caf50', '#ff9800', '#9c27b0', '#f44336'];

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investment by Industry</Typography>
// //       {Object.entries(byIndustry).map(([industry, count], idx) => {
// //         const percentage = total > 0 ? (count / total) * 100 : 0;
// //         return (
// //           <Box key={industry} sx={{ mb: 1.5 }}>
// //             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
// //               <Typography variant="caption" sx={{ fontWeight: 500 }}>{industry}</Typography>
// //               <Typography variant="caption">{count} ({percentage.toFixed(1)}%)</Typography>
// //             </Box>
// //             <LinearProgress variant="determinate" value={percentage} sx={{ height: 6, borderRadius: 3, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: colors[idx % colors.length] } }} />
// //           </Box>
// //         );
// //       })}
// //     </Card>
// //   );
// // };

// // // ==================== INVESTOR ACTIVITY REPORT CARD ====================
// // const InvestorActivityReportCard = ({ investorsData, contractsData }) => {
// //   const activeInvestors = investorsData.filter(i => i.status === "Active").length;
// //   const newInvestors = 2; // Sample new investors in last 30 days
// //   const expiringContracts = contractsData.filter(c => {
// //     const endDate = new Date(c.end_date);
// //     const today = new Date();
// //     const daysRemaining = (endDate - today) / (1000 * 60 * 60 * 24);
// //     return daysRemaining <= 90 && daysRemaining > 0;
// //   }).length;

// //   return (
// //     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
// //       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investor Activity Report</Typography>
// //       <Grid container spacing={1}>
// //         <Grid item xs={4}>
// //           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
// //             <Typography variant="h6" fontWeight="bold" color="#1976d2">{activeInvestors}</Typography>
// //             <Typography variant="caption">Active</Typography>
// //           </Box>
// //         </Grid>
// //         <Grid item xs={4}>
// //           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
// //             <Typography variant="h6" fontWeight="bold" color="#2e7d32">{newInvestors}</Typography>
// //             <Typography variant="caption">New (30d)</Typography>
// //           </Box>
// //         </Grid>
// //         <Grid item xs={4}>
// //           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
// //             <Typography variant="h6" fontWeight="bold" color="#ff9800">{expiringContracts}</Typography>
// //             <Typography variant="caption">Expiring Soon</Typography>
// //           </Box>
// //         </Grid>
// //       </Grid>
// //       <Divider sx={{ my: 1.5 }} />
// //       <Typography variant="body2" fontWeight="bold" gutterBottom>Recent Activities:</Typography>
// //       <Box sx={{ maxHeight: 100, overflowY: 'auto' }}>
// //         <Typography variant="caption" display="block">• PVH Ethiopia - Contract Renewed (Jan 2024)</Typography>
// //         <Typography variant="caption" display="block">• TAL Apparel - Expansion Approved (Feb 2024)</Typography>
// //         <Typography variant="caption" display="block">• Huajian Group - New Lease Signed (Mar 2024)</Typography>
// //       </Box>
// //     </Card>
// //   );
// // };

// // // ==================== MAIN DASHBOARD ====================
// // export default function ParkPerformanceDashboard() {
// //   const [selectedPark, setSelectedPark] = useState("all");
// //   const [loading, setLoading] = useState(false);
// //   const [activeCurrency, setActiveCurrency] = useState('usd');
// //   const [parcelsData, setParcelsData] = useState([]);
// //   const [shedsData, setShedsData] = useState([]);
// //   const [parkIdin, setParkIdin]= useState();
// //   const [revenueInPark, setRevenueInPark]= useState();
// //   const [arrearInPark, setArrearInPark]= useState();
// //   const [investorInPark, setInvestorInPark]= useState();
// //   const [investorActivityInPark, setInvestorActivityInPark]= useState();
// //   const [landUseInPark, setLandUseInPark]= useState();
// //   const [occupavailInPark, setoccupavailInPark]= useState();

// //   const decodedUser = useDecodedUser();

// //   // ========== ADDED useEffect TO FETCH PARCELS BASED ON USER'S PARK ID ==========
// //   useEffect(() => {
// //     const fetchParcelsInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
// //       setParkIdin(parkId)
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
// //         console.log("Fetching parcels for park ID:", parkId);
        
// //         const resultData = await GetParcelsInPark(parkId, false);
       
        
// //         let dataArray = [];
// //         if (resultData && Array.isArray(resultData)) {
// //           dataArray = resultData;
// //         } else if (resultData?.data && Array.isArray(resultData.data)) {
// //           dataArray = resultData.data;
// //         }
        
// //         const filteredParcel = dataArray?.map(({ geometry, ...rest }) => rest);
// //         console.log("Filtered parcels count:", filteredParcel?.length);
        
// //         if (filteredParcel && filteredParcel?.length > 0) {
// //           setParcelsData(filteredParcel);
// //           console.log("Parcels data set successfully");
// //         } else {
// //           setParcelsData([]);
// //           console.log("No parcels found for this park");
// //         }
        
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to fetch parcels data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchshedsInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetShedsByPark (parkId, false);
// //         console.log("SHEDDD:", resultData1);
// //         setShedsData(resultData1);
               
// //         let dataArray = [];
// //         if (resultData1 && Array.isArray(resultData1)) {
// //           dataArray2 = resultData1;
// //         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
// //           dataArray2 = resultData1.data;
// //         }
        
// //         let dataArray2 = [];
// //         const filteredParcel = dataArray?.map(({ geometry, ...rest }) => rest);
// //         console.log("Filtered parcels count:", filteredParcel?.length);
        
// //         if (filteredParcel && filteredParcel?.length > 0) {
// //           setParcelsData(filteredParcel);
// //           console.log("Parcels data set successfully");
// //         } else {
// //           setParcelsData([]);
// //           console.log("No parcels found for this park");
// //         }

        
        
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to fetch parcels data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchRevenueInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetRevenueByPark (parkId, false);
// //         console.log("REVENUEEEEEEEEEEEEEEEEEEEEEEEE", resultData1);
// //         setRevenueInPark(resultData1);
// //         console.log("Parcels data set successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to fetch parcels data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchArrearInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetArrearByPark (parkId, false);
// //         console.log("ARREARRRRRRRRR", resultData1);
// //         setArrearInPark(resultData1);
// //         console.log("Parcels data set successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to arrear data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchInvestorInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetInvestorInPark (parkId, false);
// //         console.log("investorRRRRRRRRRRRRRRRRr", resultData1);
// //         setInvestorInPark(resultData1);
// //         console.log("investor set successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to arrear data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchInvestorActivityInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetInvestorsActivityByPark (parkId, false);
// //         console.log("investor Activity", resultData1);
// //         setInvestorActivityInPark(resultData1);
// //         console.log("investor Activity successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to investor activity data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchLandUseInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetLandUseByPark (parkId, false);
// //         console.log("Land Use", resultData1);
// //         setLandUseInPark(resultData1);
// //         console.log("Land Use successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to Land Use data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     const fetchOccupiedAvailableInPark = async () => {
// //       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
// //       if (!parkId) {
// //         console.log("No park ID found for user:", decodedUser);
// //         return;
// //       }

// //       try {
// //         setLoading(true);
              
// //         const resultData1 = await GetLandUseByPark (parkId, false);
// //         console.log("Occupied Available parcel", resultData1);
// //         setoccupavailInPark(resultData1);
// //         console.log("Occupied Available successfully");
            
// //         setLoading(false);
// //       } catch (error) {
// //         console.error("Failed to Occupied Available data:", error);
// //         setLoading(false);
// //       }
// //     };
// //     if (decodedUser) {
// //       console.log("Land use data available, fetching parcels...");
// //       fetchParcelsInPark();
// //       fetchRevenueInPark();
// //       fetchshedsInPark();
// //       fetchArrearInPark();
// //       fetchInvestorInPark (); 
// //       fetchInvestorActivityInPark();
// //       fetchLandUseInPark();
// //       fetchOccupiedAvailableInPark()
// //     } else {
// //       console.log("Waiting for user data...");
// //     }
// //   }, [decodedUser]);
// //   // ========== END OF ADDED useEffect ==========

// //   // Filter data by park
// //   const filteredRevenue = useMemo(() => {
// //     return revenueInPark || [];  // ← Return empty array if undefined
// //   }, [revenueInPark]);  // ← Depend on revenueInPark, not parkIdin

// //   const filteredArrears = useMemo(() => {
// //     return arrearInPark || [];
// //   }, [arrearInPark]);

// //   const filteredTrade = useMemo(() => {
// //     if (selectedPark === "all") return SAMPLE_TRADE;
// //     return SAMPLE_TRADE.filter(t => t.park_name.toLowerCase().includes(selectedPark.toLowerCase()));
// //   }, [selectedPark]);

// //  const filteredInvestors = useMemo(() => {
// //   if (!investorInPark) return [];
// //   if (Array.isArray(investorInPark)) return investorInPark;
// //   if (investorInPark?.data && Array.isArray(investorInPark.data)) return investorInPark.data;
// //   return [];
// // }, [investorInPark]); 

// //   const filteredPotential = useMemo(() => {
// //     if (selectedPark === "all") return SAMPLE_POTENTIAL_INVESTORS;
// //     return SAMPLE_POTENTIAL_INVESTORS.filter(p => p.park_interested_in.toLowerCase().includes(selectedPark.toLowerCase()));
// //   }, [selectedPark]);

// //   const filteredContracts = useMemo(() => {
// //     if (selectedPark === "all") return SAMPLE_CONTRACTS;
// //     return SAMPLE_CONTRACTS.filter(c => c.park.toLowerCase().includes(selectedPark.toLowerCase()));
// //   }, [selectedPark]);

// //   // FIXED: Updated parkSummary useMemo with correct dependencies and park_id comparison
// //   const parkSummary = useMemo(() => {
// //     // Filter parcels directly using parkIdin from the logged-in user
// //     const parkParcels = parcelsData.filter(p => String(p.park_id) === String(parkIdin));
// //     const occupiedParcels = parkParcels.filter(p => p.rental_lease_status === "Occupied").length;
// //     // console.log("TOTALLLLLLL",occupiedParcels)
    
// //     let totalParcelArea = 0;
// //     if (parcelsData ) {
// //       console.log("Park ID from user:", parkIdin);
// //       console.log("Total parcels in park:", parkParcels.length);
// //       totalParcelArea = parkParcels.reduce((sum, p) => sum + (p.area || 0), 0);
// //       console.log("Total area:", totalParcelArea);
// //     }
    
// //     const occupiedArea = parkParcels.filter(p => p.rental_lease_status === "Occupied").reduce((sum, p) => sum + (p.area || 0), 0);
// //     // For sheds - you might need to convert parkIdin to number if SAMPLE_SHEDS uses numbers
// //     const parkSheds = shedsData.filter(s => String(s.park_id) === String(parkIdin));
// //     const occupiedSheds = shedsData.filter(s => s.status_utilization === "Occupied").length;
// //     console.log("SHEDDDDDDDDDDssss",occupiedSheds)
    
// //     return {
// //       occupancyRate: totalParcelArea > 0 ? (occupiedArea / totalParcelArea) * 100 : 0,
// //       parcelRatio: parkParcels.length > 0 ? (occupiedParcels / parkParcels.length) * 100 : 0,
// //       shedOccupancy: parkSheds.length > 0 ? (occupiedSheds / parkSheds.length) * 100 : 0,
// //       totalArea: totalParcelArea, // You might want to get this from somewhere else or calculate from parcels
// //       occupiedArea,
// //       totalParcels: parkParcels.length,
// //       occupiedParcels,
// //       parkName: "" // You might want to get this from the user or API
// //     };
// //   }, [parkIdin, parcelsData]);// Keep dependencies as is// FIXED: Added selectedPark to dependencies and removed unused parkIdin

// //   // Revenue by park for charts
// //   const revenueByPark = useMemo(() => {
// //     const map = {};
// //     SAMPLE_REVENUE.forEach(r => {
// //       map[r.park_name] = (map[r.park_name] || 0) + (r.amount || 0);
// //     });
// //     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
// //   }, []);

// //   const outstandingByPark = useMemo(() => {
// //     const map = {};
// //     SAMPLE_ARREARS.forEach(a => {
// //       map[a.park_name] = (map[a.park_name] || 0) + (a.outstanding || 0);
// //     });
// //     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
// //   }, []);

// //   const investmentByType = useMemo(() => {
// //     const map = {};
// //     SAMPLE_INVESTORS.forEach(i => {
// //       const type = i.investment_type || "Other";
// //       map[type] = (map[type] || 0) + 1;
// //     });
// //     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
// //   }, []);

// //   const topSectors = useMemo(() => {
// //     const map = {};
// //     SAMPLE_POTENTIAL_INVESTORS.forEach(p => {
// //       const sector = p.sector_of_interest || "Other";
// //       map[sector] = (map[sector] || 0) + 1;
// //     });
// //     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
// //   }, []);

// //   const topParksInterest = useMemo(() => {
// //     const map = {};
// //     SAMPLE_POTENTIAL_INVESTORS.forEach(p => {
// //       const park = p.park_interested_in || "Other";
// //       map[park] = (map[park] || 0) + 1;
// //     });
// //     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
// //   }, []);
// // {console.log("LAND USEEEEEEEEEE", landUseInPark)}
// // const landUseData = useMemo(() => {
// //   // Safety check - if data hasn't loaded yet, return zeros
// //   console.log("LandUseInPark data:", landUseInPark);
  
// //   if (!landUseInPark) {
// //     return { 'Parcels': 0, 'Green Areas': 0, 'Roads': 0 };
// //   }
  
// //   // Handle different possible data structures
// //   let totalArea = 0;
// //   let availableArea = 0;
// //   let holdArea = 0;
  
// //   // If it's an array with at least one item
// //   if (Array.isArray(landUseInPark) && landUseInPark.length > 0) {
// //     totalArea = landUseInPark[0].totalarea || landUseInPark[0].total_area || 0;
// //     availableArea = landUseInPark[0].availablearea || landUseInPark[0].available_area || 0;
// //     holdArea = landUseInPark[0].holdarea || landUseInPark[0].hold_area || 0;
// //   } 
// //   // If it's a single object
// //   else if (typeof landUseInPark === 'object' && !Array.isArray(landUseInPark)) {
// //     totalArea = landUseInPark.totalarea || landUseInPark.total_area || 0;
// //     availableArea = landUseInPark.availablearea || landUseInPark.available_area || 0;
// //     holdArea = landUseInPark.holdarea || landUseInPark.hold_area || 0;
// //   }
  
// //   console.log("Processed land use data:", { totalArea, availableArea, holdArea });
  
// //   return { 
// //     'Total Area': totalArea, 
// //     'Available Area': availableArea, 
// //     'Hold Area': holdArea 
// //   };
// // }, [landUseInPark]);// ← Changed dependency from parcelsData to landUseInPark


// // // Add safety check for investorActivityInPark when calculating totals
// // const totalEmployees = useMemo(() => {
// //   if (!investorActivityInPark) return 0;
// //   if (!Array.isArray(investorActivityInPark)) return 0;
  
// //   // Create a Map to store the latest record for each investor_id
// //   const latestRecordsMap = new Map();
  
// //   investorActivityInPark.forEach(record => {
// //     const investorId = record.investor_id;
// //     const currentDate = new Date(record.recorded_on);
    
// //     if (!latestRecordsMap.has(investorId)) {
// //       // First record for this investor
// //       latestRecordsMap.set(investorId, record);
// //     } else {
// //       // Compare dates and keep the latest
// //       const existingRecord = latestRecordsMap.get(investorId);
// //       const existingDate = new Date(existingRecord.recorded_on);
      
// //       if (currentDate > existingDate) {
// //         latestRecordsMap.set(investorId, record);
// //       }
// //     }
// //   });
  
// //   // Sum up the latest records
// //   const latestRecords = Array.from(latestRecordsMap.values());
  
// //   return latestRecords.reduce((sum, e) => {
// //     const laborFemale = toNumber(e.emp_labor_female);
// //     const laborMale = toNumber(e.emp_labor_male);
// //     const profFemale = toNumber(e.emp_prof_female);
// //     const profMale = toNumber(e.emp_prof_male);
// //     return sum + laborFemale + laborMale + profFemale + profMale;
// //   }, 0);
// // }, [investorActivityInPark]);


// // const totalExport = useMemo(() => {
// //   if (!investorActivityInPark) return 0;
// //   if (!Array.isArray(investorActivityInPark)) return 0;
// //   return investorActivityInPark.reduce((sum, t) => sum + toNumber(t.export_amount), 0);
// // }, [investorActivityInPark]);

// // const totalImport = useMemo(() => {
// //   if (!investorActivityInPark) return 0;
// //   if (!Array.isArray(investorActivityInPark)) return 0;
// //   return investorActivityInPark.reduce((sum, t) => sum + toNumber(t.import_substitution), 0);
// // }, [investorActivityInPark]);

// //   // const totalEmployees = investorActivityInPark.reduce((sum, e) => sum + (e.emp_labor_female + e.emp_labor_male + e.emp_prof_female + e.emp_prof_male), 0);
// //   // const totalExport = investorActivityInPark.reduce((sum, t) => sum + t.export_amount, 0);
// //   // const totalImport = investorActivityInPark.reduce((sum, t) => sum + t.import_amount, 0);
// //   // const totalInvestors = SAMPLE_INVESTORS.length;
// //   // const totalPotential = SAMPLE_POTENTIAL_INVESTORS.length;
// //   // const convertedCount = SAMPLE_POTENTIAL_INVESTORS.filter(pot => SAMPLE_INVESTORS.some(inv => inv.email === pot.email)).length;
// //   // const conversionRate = totalPotential > 0 ? (convertedCount / totalPotential) * 100 : 0;
// //   // const totalCapital = SAMPLE_INVESTORS.reduce((sum, i) => sum + i.capital, 0);

// //   if (loading) {
// //     return (
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //         <CircularProgress /><Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ bgcolor: '#f4f9ff', width: '100%', mx: 0, py: 1 }}>
// //       {/* Header */}
// //       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
// //           <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
          
// //            <Grid item xs={12} md={12}>
// //           <IPDCWelcomeMessage messageTitle="Park Staff" />
// //         </Grid>
// //           </Typography>
// //           {/* <FormControl sx={{ minWidth: 200 }} size="small">
// //             <InputLabel>Select Park</InputLabel>
// //             <Select value={selectedPark} onChange={(e) => setSelectedPark(e.target.value)} label="Select Park">
// //               <MenuItem value="all">All Parks</MenuItem>
// //               {SAMPLE_PARKS.map(park => (
// //                 <MenuItem key={park.id} value={park.name.toLowerCase()}>{park.name}</MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl> */}
// //         </Box>
// //       </Container>

    

// //       {/* Bold Line Separator */}
// //       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
// //       </Container>

// //       {/* ========== SECTION 2: KEY METRICS ========== */}
// //       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
// //         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
// //           <AssessmentIcon sx={{ color: '#1976d2', mr: 1 }} />
// //           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Key Performance Metrics</Typography>
// //         </Box>
// //         <Grid container spacing={2}>
// //           <Grid item xs={12} sm={6} md={4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
// //               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Occupancy Rate</Typography>
// //               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.occupancyRate)}</Typography>
// //               <ProgressBarCell value={parkSummary.occupancyRate} label="Occupancy" />
// //             </Card>
// //           </Grid>
// //           {/* <Grid item xs={12} sm={6} md={3}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
// //               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Parcel Ratio</Typography>
// //               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.parcelRatio)}</Typography>
// //               <ProgressBarCell value={parkSummary.parcelRatio} label="Parcel" color="#1976d2" />
// //             </Card>
// //           </Grid> */}
// //           <Grid item xs={12} sm={6} md={4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
// //               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Shed Occupancy</Typography>
// //               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.shedOccupancy)}</Typography>
// //               <ProgressBarCell value={parkSummary.shedOccupancy} label="Shed" color="#795548" />
// //             </Card>
// //           </Grid>
// //           <Grid item xs={12} sm={6} md={4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
// //               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Area</Typography>
// //               <Typography variant="h5" fontWeight="bold">{parkSummary.totalArea.toFixed(1)} m²</Typography>
// //               <Typography variant="caption" color="textSecondary">Occupied: {parkSummary.occupiedArea.toFixed(1)}m²</Typography>
// //             </Card>
// //           </Grid>
// //         </Grid>
// //       </Container>

// //       {/* Bold Line Separator */}
// //       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
// //       </Container>

// //       {/* ========== SECTION 3: REPORTS ROW 1 ========== */}
// //       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
// //         <Grid container spacing={2}>
// //           <Grid item xs={12} md={4}>
         
// //             <QuarterlyReportCard revenueData={filteredRevenue} arrearsData={filteredArrears} />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <InvestorSummaryCard investorsData={filteredInvestors} potentialInvestors={filteredPotential} />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <InvestmentByIndustryCard investorsData={filteredInvestors} />
// //           </Grid>
// //         </Grid>
// //       </Container>

// //       {/* ========== SECTION 4: REPORTS ROW 2 ========== */}   

// //       {/* Bold Line Separator */}
// //       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
// //       </Container>

// //       {/* ========== SECTION 5: FINANCIAL ANALYTICS ========== */}
// //       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
// //         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
// //           <BarChartIcon sx={{ color: '#1976d2', mr: 1 }} />
// //           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Investor Activities</Typography>
// //         </Box>

// //         {/* KPI Cards */}
// //         <Grid container spacing={2} sx={{ mb: 3 }}>
// //   <Grid item xs={12} sm={6} md={3}>
// //     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
// //       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Revenue</Typography>
      
// //       <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
// //         {/* USD Revenue */}
// //         <Box>
// //           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
// //           <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
// //             {formatCurrencyUSD(
// //               filteredRevenue
// //                 .filter(r => r.payment_mode?.toLowerCase() === "usd")
// //                 .reduce((s, r) => s + toNumber(r.amount), 0)
// //             )}
// //           </Typography>
// //         </Box>
        
// //         <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        
// //         {/* Birr Revenue */}
// //         <Box>
// //           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
// //           <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
// //             {formatCurrencyETB(
// //               filteredRevenue
// //                 .filter(r => r.payment_mode?.toLowerCase() === "birr" || r.payment_mode?.toLowerCase() === "etb")
// //                 .reduce((s, r) => s + toNumber(r.amount), 0)
// //             )}
// //           </Typography>
// //         </Box>
// //       </Box>
// //     </Card>
// //   </Grid>
  
// //   <Grid item xs={12} sm={6} md={3}>
// //     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
// //       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Outstanding</Typography>
      
// //       <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
// //         {/* USD Outstanding */}
// //         <Box>
// //           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
// //           <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
// //             {formatCurrencyUSD(
// //               filteredArrears
// //                 .filter(a => a.payment_mode?.toLowerCase() === "usd")
// //                 .reduce((s, a) => s + toNumber(a.outstanding), 0)
// //             )}
// //           </Typography>
// //         </Box>
        
// //         <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        
// //         {/* Birr Outstanding */}
// //         <Box>
// //           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
// //           <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
// //             {formatCurrencyETB(
// //               filteredArrears
// //                 .filter(a => a.payment_mode?.toLowerCase() === "birr" || a.payment_mode?.toLowerCase() === "etb")
// //                 .reduce((s, a) => s + toNumber(a.outstanding), 0)
// //             )}
// //           </Typography>
// //         </Box>
// //       </Box>
// //     </Card>
// //   </Grid>
  
// //   <Grid item xs={12} sm={6} md={3}>
// //     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
// //       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Export</Typography>
// //       <Typography variant="h6" fontWeight="bold" color="#1976d2" sx={{ mt: 1 }}>
// //         {formatCurrencyUSD(totalExport)}
// //       </Typography>
// //     </Card>
// //   </Grid>
  
// //   <Grid item xs={12} sm={6} md={3}>
// //     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
// //       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Employees</Typography>
// //       <Typography variant="h6" fontWeight="bold" sx={{ mt: 1 }}>
// //         {formatNumber(totalEmployees)}
// //       </Typography>
// //     </Card>
// //   </Grid>
// // </Grid>
// //         {/* Charts */}
        
// //       </Container>

// //       {/* Bold Line Separator */}
// //       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
// //       </Container>

// //       {/* ========== SECTION 6: LAND USE & INVESTMENT ========== */}

// //       {console.log("KOKOKOKOKOKOK",landUseData)}
// //      {/* ========== SECTION 6: LAND USE & INVESTMENT ========== */}

// // {console.log("KOKOKOKOKOKOK", landUseData)}
// // {console.log("Occupancy Availability Data:", occupavailInPark)}

// // <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
// //   <Grid container spacing={2}>
// //     <Grid item xs={12} md={6}>
// //       <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
// //         <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
// //           Land Use Proportion
// //         </Typography>
// //         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
// //           <Box sx={{ position: 'relative', width: 180, height: 180 }}>
// //             <svg width={180} height={180} viewBox="0 0 180 180">
// //               {(() => {
// //                 const items = Object.keys(landUseData);
// //                 const total = items.reduce((sum, key) => sum + landUseData[key], 0);
// //                 const colors = ['#1976d2', '#4caf50', '#ff9800'];
// //                 let startAngle = 0;
// //                 const centerX = 90, centerY = 90, radius = 70;
// //                 return items.map((key, index) => {
// //                   const value = landUseData[key];
// //                   const percentage = total > 0 ? (value / total) * 100 : 0;
// //                   const angle = (percentage / 100) * 360;
// //                   const endAngle = startAngle + angle;
// //                   const startRad = (startAngle * Math.PI) / 180;
// //                   const endRad = (endAngle * Math.PI) / 180;
// //                   const x1 = centerX + radius * Math.cos(startRad);
// //                   const y1 = centerY + radius * Math.sin(startRad);
// //                   const x2 = centerX + radius * Math.cos(endRad);
// //                   const y2 = centerY + radius * Math.sin(endRad);
// //                   const largeArcFlag = angle > 180 ? 1 : 0;
// //                   const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
// //                   startAngle = endAngle;
// //                   return <path key={key} d={pathData} fill={colors[index]} stroke="white" strokeWidth="2" />;
// //                 });
// //               })()}
// //               <circle cx={90} cy={90} r="35" fill="white" />
// //               <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
// //               <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
// //                 {formatNumber(Object.values(landUseData).reduce((a, b) => a + b, 0))} m²
// //               </text>
// //             </svg>
// //           </Box>
// //           <Box>
// //             {Object.entries(landUseData).map(([key, value], idx) => {
// //               const total = Object.values(landUseData).reduce((a, b) => a + b, 0);
// //               const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
// //               const colors = ['#1976d2', '#4caf50', '#ff9800'];
// //               return (
// //                 <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
// //                   <Box sx={{ width: 12, height: 12, bgcolor: colors[idx], borderRadius: 1 }} />
// //                   <Typography variant="caption">
// //                     {key}: {value.toFixed(1)} m² ({percentage}%)
// //                   </Typography>
// //                 </Box>
// //               );
// //             })}
// //           </Box>
// //         </Box>
// //       </Box>
// //     </Grid>
    
// //     {/* New: Land Occupancy Status Chart */}
// //     <Grid item xs={12} md={6}>
// //       <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
// //         <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
// //           Land Occupancy Status
// //         </Typography>
// //         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
// //           <Box sx={{ position: 'relative', width: 180, height: 180 }}>
// //             <svg width={180} height={180} viewBox="0 0 180 180">
// //               {(() => {
// //                 // Prepare occupancy data
// //                 let occupancyData = {};
// //                 if (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0) {
// //                   occupancyData = {
// //                     'Available': occupavailInPark[0].availablearea || occupavailInPark[0].availableArea || 0,
// //                     'Hold': occupavailInPark[0].holdarea || occupavailInPark[0].holdArea || 0
// //                   };
// //                 } else if (occupavailInPark && typeof occupavailInPark === 'object' && !Array.isArray(occupavailInPark)) {
// //                   occupancyData = {
// //                     'Available': occupavailInPark.availablearea || occupavailInPark.availableArea || 0,
// //                     'Hold': occupavailInPark.holdarea || occupavailInPark.holdArea || 0
// //                   };
// //                 }
                
// //                 const items = Object.keys(occupancyData);
// //                 const total = items.reduce((sum, key) => sum + occupancyData[key], 0);
// //                 const colors = ['#4caf50', '#ff9800', '#f44336'];
// //                 let startAngle = 0;
// //                 const centerX = 90, centerY = 90, radius = 70;
                
// //                 if (items.length === 0 || total === 0) {
// //                   return (
// //                     <text x={90} y={90} textAnchor="middle" fontSize="4" fill="#999">
// //                       No data available
// //                     </text>
// //                   );
// //                 }
                
// //                 return items.map((key, index) => {
// //                   const value = occupancyData[key];
// //                   const percentage = total > 0 ? (value / total) * 100 : 0;
// //                   const angle = (percentage / 100) * 360;
// //                   const endAngle = startAngle + angle;
// //                   const startRad = (startAngle * Math.PI) / 180;
// //                   const endRad = (endAngle * Math.PI) / 180;
// //                   const x1 = centerX + radius * Math.cos(startRad);
// //                   const y1 = centerY + radius * Math.sin(startRad);
// //                   const x2 = centerX + radius * Math.cos(endRad);
// //                   const y2 = centerY + radius * Math.sin(endRad);
// //                   const largeArcFlag = angle > 180 ? 1 : 0;
// //                   const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
// //                   startAngle = endAngle;
// //                   return <path key={key} d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="2" />;
// //                 });
// //               })()}
// //               <circle cx={90} cy={90} r="35" fill="white" />
// //               <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
// //               <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
// //                 {formatNumber(
// //                   (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0)
// //                     ? (occupavailInPark[0].totalarea || occupavailInPark[0].totalArea || 0)
// //                     : (occupavailInPark?.totalarea || occupavailInPark?.totalArea || 0)
// //                 )} m²
// //               </text>
// //             </svg>
// //           </Box>
// //           <Box>
// //             {(() => {
// //               let occupancyData = {};
// //               if (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0) {
// //                 occupancyData = {
// //                   'Available': occupavailInPark[0].availablearea || occupavailInPark[0].availableArea || 0,
// //                   'Hold': occupavailInPark[0].holdarea || occupavailInPark[0].holdArea || 0
// //                 };
// //               } else if (occupavailInPark && typeof occupavailInPark === 'object' && !Array.isArray(occupavailInPark)) {
// //                 occupancyData = {
// //                   'Available': occupavailInPark.availablearea || occupavailInPark.availableArea || 0,
// //                   'Hold': occupavailInPark.holdarea || occupavailInPark.holdArea || 0
// //                 };
// //               }
              
// //               const total = Object.values(occupancyData).reduce((a, b) => a + b, 0);
// //               const colors = ['#4caf50', '#ff9800', '#f44336'];
              
// //               return Object.entries(occupancyData).map(([key, value], idx) => {
// //                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
// //                 return (
// //                   <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
// //                     <Box sx={{ width: 12, height: 12, bgcolor: colors[idx % colors.length], borderRadius: 1 }} />
// //                     <Typography variant="caption">
// //                       {key}: {value.toFixed(1)} m² ({percentage}%)
// //                     </Typography>
// //                   </Box>
// //                 );
// //               });
// //             })()}
// //           </Box>
// //         </Box>
// //       </Box>
// //     </Grid>
// //   </Grid>
// // </Container>

// //       {/* Bold Line Separator */}
// //       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
// //         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
// //       </Container>

// //       {/* ========== SECTION 7: PROMOTION & MARKETING ========== */}
      
// //     </Box>
// //   );
// // }
// //****************************************Replaced with the flf after database changed */
// import { useEffect, useState, useMemo, useCallback } from "react";
// import { IPDCWelcomeMessage } from "../../../components"; //IPDCMessageCard
// import { GetParcelsInPark,
//   GetShedsByPark, 
//   GetRevenueByPark,
//   GetArrearByPark,
//   GetInvestorInPark,
//   GetInvestorsActivityByPark,
//   GetOccuAvaByPark,
//   GetLandUseByPark   } from "../../Views/Shared/CommonData/CommonData";
// import useDecodedUser from "../../../services/hooks/useDecodedUser";
// import {
//   ParksBySectorCard,
//   ParksByOccupancyCard,
//   HandoverCard,
//   //the flf are newww
//   // InvestorActivityReportCard,
//  } from "../Shared/DashboardCards";
// import LandUseProportionCard from '../LandInfraDevelopment/Head/DashboardDetail/LandUseProportionCard.jsx';
// import ShedParcelRatioCard from '../LandInfraDevelopment/Head/DashboardDetail/ShedParcelRatioCard.jsx';

// import {
//   Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
//   Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
//   FormControl, InputLabel, Select, IconButton, CircularProgress,
//   ToggleButton, ToggleButtonGroup, Alert
// } from "@mui/material";
// import {
//   Business as BusinessIcon,
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   WarningAmber as WarningIcon,
//   Receipt as ReceiptIcon,
//   AccountBalance as AccountBalanceIcon,
//   AttachMoney as MoneyIcon,
//   Assessment as AssessmentIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   Download as DownloadIcon,
//   BarChart as BarChartIcon,
//   PieChart as PieChartIcon,
//   ShowChart as ShowChartIcon,
//   People as PeopleIcon,
//   LocationOn as LocationOnIcon,
//   CheckCircle as CheckCircleIcon,
//   Warehouse as WarehouseIcon,
//   ViewModule as ViewModuleIcon,
//   Straighten as StraightenIcon,
//   Home as HomeIcon,
//   Agriculture as AgricultureIcon,
//   Map as MapIcon
// } from "@mui/icons-material";




// // Green Areas Data
// const SAMPLE_GREEN_AREAS = [
//   { park_id: 1, capacity: 15.5 },
//   { park_id: 2, capacity: 18.0 },
//   { park_id: 3, capacity: 12.0 },
//   { park_id: 4, capacity: 10.5 },
//   { park_id: 5, capacity: 8.0 }
// ];

// // Roads Data
// const SAMPLE_ROADS = [
//   { park_id: 1, capacity: 22.5 },
//   { park_id: 2, capacity: 25.0 },
//   { park_id: 3, capacity: 18.0 },
//   { park_id: 4, capacity: 15.0 }
// ];

// // Land Leased Data
// const SAMPLE_LAND_LEASED = [
//   { upin: "BL-001", parcel_state: "Occupied" },
//   { upin: "BL-002", parcel_state: "Occupied" },
//   { upin: "HW-001", parcel_state: "Occupied" },
//   { upin: "HW-002", parcel_state: "Occupied" },
//   { upin: "AD-001", parcel_state: "Occupied" },
//   { upin: "KL-001", parcel_state: "Occupied" }
// ];

// // Revenue Data
// const SAMPLE_REVENUE = [
//   { park_name: "Bole Lemi", amount: 2500000, payment_mode: "USD", month: "01", year: "2024" },
//   { park_name: "Bole Lemi", amount: 1800000, payment_mode: "USD", month: "02", year: "2024" },
//   { park_name: "Hawassa", amount: 3200000, payment_mode: "USD", month: "01", year: "2024" },
//   { park_name: "Hawassa", amount: 2800000, payment_mode: "USD", month: "02", year: "2024" },
//   { park_name: "Adama", amount: 1500000, payment_mode: "Birr", month: "01", year: "2024" },
//   { park_name: "Kilinto", amount: 1200000, payment_mode: "Birr", month: "01", year: "2024" },
//   { park_name: "Debre Birhan", amount: 800000, payment_mode: "USD", month: "01", year: "2024" }
// ];

// // Arrears Data
// const SAMPLE_ARREARS = [
//   { park_name: "Bole Lemi", outstanding: 450000, payment_mode: "USD", overdue_days: 45 },
//   { park_name: "Hawassa", outstanding: 620000, payment_mode: "USD", overdue_days: 60 },
//   { park_name: "Adama", outstanding: 280000, payment_mode: "Birr", overdue_days: 30 },
//   { park_name: "Kilinto", outstanding: 150000, payment_mode: "Birr", overdue_days: 15 }
// ];

// // Employment Data
// const SAMPLE_EMPLOYMENT = [
//   { park_name: "Bole Lemi", emp_labor_female: 1200, emp_labor_male: 800, emp_prof_female: 150, emp_prof_male: 200, year: "2024" },
//   { park_name: "Hawassa", emp_labor_female: 2500, emp_labor_male: 1500, emp_prof_female: 200, emp_prof_male: 180, year: "2024" },
//   { park_name: "Adama", emp_labor_female: 600, emp_labor_male: 500, emp_prof_female: 80, emp_prof_male: 70, year: "2024" },
//   { park_name: "Kilinto", emp_labor_female: 300, emp_labor_male: 250, emp_prof_female: 60, emp_prof_male: 90, year: "2024" }
// ];

// // Trade Data
// const SAMPLE_TRADE = [
//   { park_name: "Bole Lemi", export_amount: 4500000, import_amount: 1200000, import_substitution: 500000, year: "2024" },
//   { park_name: "Hawassa", export_amount: 8500000, import_amount: 2000000, import_substitution: 800000, year: "2024" },
//   { park_name: "Adama", export_amount: 1800000, import_amount: 600000, import_substitution: 300000, year: "2024" }
// ];

// // Investors Data
// const SAMPLE_INVESTORS = [
//   { id: 1, company_name: "PVH Ethiopia", capital: 25000000, nationality_origin: "USA", status: "Active", email: "contact@pvh.com", investment_type: "Textile" },
//   { id: 2, company_name: "TAL Apparel", capital: 18000000, nationality_origin: "Hong Kong", status: "Active", email: "info@tal.com", investment_type: "Garment" },
//   { id: 3, company_name: "Huajian Group", capital: 35000000, nationality_origin: "China", status: "Active", email: "info@huajian.com", investment_type: "Shoes" },
//   { id: 4, company_name: "Jay Jay Textile", capital: 12000000, nationality_origin: "India", status: "Active", email: "contact@jayjay.com", investment_type: "Textile" }
// ];

// // Potential Investors Data
// const SAMPLE_POTENTIAL_INVESTORS = [
//   { email: "contact@nike.com", sector_of_interest: "Apparel", park_interested_in: "Hawassa" },
//   { email: "info@adidas.com", sector_of_interest: "Apparel", park_interested_in: "Bole Lemi" },
//   { email: "contact@pvh.com", sector_of_interest: "Textile", park_interested_in: "Bole Lemi" },
//   { email: "info@h&m.com", sector_of_interest: "Fashion", park_interested_in: "Hawassa" },
//   { email: "contact@zara.com", sector_of_interest: "Fashion", park_interested_in: "Debre Birhan" }
// ];

// // Active Contracts Data
// const SAMPLE_CONTRACTS = [
//   { investor: "PVH Ethiopia", park: "Bole Lemi", area: 5.2, start_date: "2020-01-15", end_date: "2030-01-14", status: "Active" },
//   { investor: "TAL Apparel", park: "Hawassa", area: 6.0, start_date: "2019-06-01", end_date: "2029-05-31", status: "Active" },
//   { investor: "Huajian Group", park: "Bole Lemi", area: 4.8, start_date: "2021-03-10", end_date: "2031-03-09", status: "Active" }
// ];

// // ==================== HELPER FUNCTIONS ====================
// const toNumber = (value) => {
//   if (typeof value === 'number' && !isNaN(value)) return value;
//   if (typeof value === 'string') {
//     // Remove commas, dollar signs, currency symbols, and spaces
//     const cleaned = value.replace(/[$,]/g, '').trim();
//     const num = parseFloat(cleaned);
//     return isNaN(num) ? 0 : num;
//   }
//   return 0;
// };

// const formatNumber = (number) => {
//   const num = toNumber(number);
//   if (num === 0) return "0";
//   return new Intl.NumberFormat('en-US').format(num);
// };

// const formatCurrency = (amount, paymentMode = "usd") => {
//   const formatted = formatNumber(amount);
//   const mode = paymentMode?.toLowerCase() || "usd";
//   if (mode === "usd") return `$${formatted}`;
//   return `${formatted} ETB`;
// };

// const formatCurrencyUSD = (amount) => `$${formatNumber(amount)}`;
// const formatCurrencyETB = (amount) => `${formatNumber(amount)} ETB`;
// const formatPercentage = (value) => {
//   const num = toNumber(value);
//   if (num === 0) return "0%";
//   return `${num.toFixed(1)}%`;
// };

// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd" || mode === "USD") return "usd";
//   if (mode === "birr" || mode === "etb" || mode === "Birr") return "birr";
//   return mode;
// };

// // ==================== PROGRESS BAR COMPONENT ====================
// const ProgressBarCell = ({ value, label, color }) => {
//   const percentage = Math.min(100, Math.max(0, toNumber(value)));
//   const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
//   return (
//     <Box sx={{ minWidth: 80 }}>
//       <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
//         <Box>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//             <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
//               {formatPercentage(percentage)}
//             </Typography>
//           </Box>
//           <LinearProgress
//             variant="determinate"
//             value={percentage}
//             sx={{
//               height: 5, borderRadius: 2.5, backgroundColor: '#e0e0e0',
//               '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
//             }}
//           />
//         </Box>
//       </Tooltip>
//     </Box>
//   );
// };

// // ==================== DONUT CHART COMPONENT ====================
// const DonutChartComponent = ({ title, data, colors, formatValue, total, sx }) => {
//   const items = Object.keys(data);
//   const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
//   const donutColors = colors || ['#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012'];
  
//   if (items.length === 0 || totalValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%', ...sx }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   let startAngle = 0;
//   const centerX = 80, centerY = 80, radius = 55;
//   const svgSize = 180;
  
//   return (
//     <Box sx={{ p: 0.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%', ...sx }}>
//       <Typography variant="subtitle2" sx={{ textAlign: 'center', mb: 1, fontSize: '1.2rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {items.map((key, index) => {
//               const value = data[key] || 0;
//               const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
//               const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//             <circle cx={centerX} cy={centerY} r="32" fill="white" />
//             <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
//             <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
//           </svg>
//         </Box>
//         <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
//           {items.slice(0, 5).map((key, index) => {
//             const value = data[key] || 0;
//             const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
//             return (
//               <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
//                 <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{formatValue(value)} ({percentage}%)</Typography>
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== HORIZONTAL BAR CHART ====================
// const HorizontalBarChart = ({ title, data, dataKey, color, formatValue, sx }) => {
//   let processedData = data;
//   const isFlatFormat = Object.values(data).some(value => typeof value === 'number');
  
//   if (isFlatFormat) {
//     processedData = {};
//     Object.keys(data).forEach(key => {
//       processedData[key] = { [dataKey]: data[key] };
//     });
//   }
  
//   const items = Object.keys(processedData);
//   const maxValue = Math.max(...Object.values(processedData).map(d => d[dataKey] || 0), 0);
  
//   if (items.length === 0 || maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
//       <Typography variant="subtitle2" sx={{ textAlign: 'center', mb: 1.5, fontSize: '1.2rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {items.slice(0, 6).map((item) => {
//           const value = processedData[item][dataKey] || 0;
//           const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
//           return (
//             <Box key={item}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
//               </Box>
//               <LinearProgress variant="determinate" value={percentage} sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 } }} />
//             </Box>
//           );
//         })}
//       </Box>
//     </Box>
//   );
// };

// // ==================== QUARTERLY REPORT CARD ====================
// const QuarterlyReportCard = ({ revenueData, arrearsData }) => {
//   // Ensure revenueData and arrearsData are arrays
//   const safeRevenueData = Array.isArray(revenueData) ? revenueData : [];
//   const safeArrearsData = Array.isArray(arrearsData) ? arrearsData : [];
  
//   const currentYear = new Date().getFullYear();

//   const quarters = [
//     { label: `Q1 ${currentYear}`, months: ["01", "02", "03"] },
//     { label: `Q2 ${currentYear}`, months: ["04", "05", "06"] },
//     { label: `Q3 ${currentYear}`, months: ["07", "08", "09"] },
//     { label: `Q4 ${currentYear}`, months: ["10", "11", "12"] }
//   ];
 
//   const quarterData = quarters.map(q => {
//     // Separate revenue by currency
//     const revenueUSD = safeRevenueData
//       .filter(r => q.months.includes(r.month) && 
//                    String(r.year) === String(currentYear) && 
//                    (r.payment_mode?.toLowerCase() === "usd" || r.payment_mode?.toLowerCase() === "usd"))
//       .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
//     const revenueBirr = safeRevenueData
//       .filter(r => q.months.includes(r.month) && 
//                    String(r.year) === String(currentYear) && 
//                    (r.payment_mode?.toLowerCase() === "birr" || r.payment_mode?.toLowerCase() === "etb"))
//       .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
//     const totalRevenue = revenueUSD + revenueBirr;
    
//     // Separate outstanding by currency
//     const outstandingUSD = safeArrearsData
//       .filter(a => (a.payment_mode?.toLowerCase() === "usd" || a.payment_mode?.toLowerCase() === "usd"))
//       .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
    
//     const outstandingBirr = safeArrearsData
//       .filter(a => (a.payment_mode?.toLowerCase() === "birr" || a.payment_mode?.toLowerCase() === "etb"))
//       .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
    
//     const totalOutstanding = outstandingUSD + outstandingBirr;
   
//     return { 
//       label: q.label, 
//       revenueUSD, 
//       revenueBirr,
//       totalRevenue,
//       outstandingUSD,
//       outstandingBirr,
//       totalOutstanding,
//       collectedUSD: revenueUSD - outstandingUSD,
//       collectedBirr: revenueBirr - outstandingBirr,
//       totalCollected: totalRevenue - totalOutstanding
//     };
//   });

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Quarterly Report</Typography>
//       <Box sx={{ overflowX: 'auto' }}>
//         <Box sx={{ display: 'flex', gap: 2, minWidth: 600 }}>
//           {quarterData.map((q, idx) => (
//             <Box key={idx} sx={{ flex: 1, textAlign: 'center', p: 1, bgcolor: 'white', borderRadius: 1 }}>
//               <Typography variant="body2" fontWeight="bold">{q.label}</Typography>
              
//               {/* USD Section */}
//               <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>USD</Typography>
//               <Typography variant="caption" color="textSecondary">Revenue</Typography>
//               <Typography variant="body2" color="green">{formatCurrencyUSD(q.revenueUSD)}</Typography>
             
//               <Typography variant="caption" color="textSecondary">Outstanding</Typography>
//               <Typography variant="body2" color="red">{formatCurrencyUSD(q.outstandingUSD)}</Typography>
              
//               <Divider sx={{ my: 1 }} />
              
//               {/* Birr Section */}
//               <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>BIRR</Typography>
//               <Typography variant="caption" color="textSecondary">Revenue</Typography>
//               <Typography variant="body2" color="green">{formatCurrencyETB(q.revenueBirr)}</Typography>
              
//               <Typography variant="caption" color="textSecondary">Outstanding</Typography>
//               <Typography variant="body2" color="red">{formatCurrencyETB(q.outstandingBirr)}</Typography>
              
            
              
              
//             </Box>
//           ))}
//         </Box>
//       </Box>
//     </Card>
//   );
// };

// // ==================== INVESTOR SUMMARY CARD ====================
// const InvestorSummaryCard = ({ investorsData, potentialInvestors }) => {
//   // Ensure investorsData is an array
//   const safeInvestorsData = Array.isArray(investorsData) ? investorsData : [];
  
//   const activeInvestors = safeInvestorsData.filter(i => i.status === "active" || i.status === "Operational").length;
//   const byNationality = {};
//   safeInvestorsData.forEach(i => {
//     const country = i.nationality_origin || "Unknown";
//     byNationality[country] = (byNationality[country] || 0) + 1;
//   });

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investor Summary</Typography>
//       <Grid container spacing={1}>
//         <Grid item xs={6}>
//           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
//             <Typography variant="h5" fontWeight="bold" color="#1976d2">{safeInvestorsData.length}</Typography>
//             <Typography variant="caption">Total Investors</Typography>
//           </Box>
//         </Grid>
//         <Grid item xs={6}>
//           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
//             <Typography variant="h5" fontWeight="bold" color="#2e7d32">{activeInvestors}</Typography>
//             <Typography variant="caption">Active Investors</Typography>
//           </Box>
//         </Grid>
//         <Grid item xs={12}>
//           <Divider sx={{ my: 1 }} />
//           <Typography variant="body2" fontWeight="bold" gutterBottom>By Nationality:</Typography>
//           {Object.entries(byNationality).slice(0, 4).map(([country, count]) => (
//             <Box key={country} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//               <Typography variant="caption">{country}</Typography>
//               <Typography variant="caption" fontWeight="bold">{count}</Typography>
//             </Box>
//           ))}
//         </Grid>
//       </Grid>
//     </Card>
//   );
// };

// // ==================== ARREAR REPORT CARD ====================
// const ArrearReportCard = ({ arrearsData }) => {
//   // Ensure arrearsData is an array
//   const safeArrearsData = Array.isArray(arrearsData) ? arrearsData : [];
  
//   const totalOutstanding = safeArrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
//   const highRisk = safeArrearsData.filter(a => a.overdue_days > 90).length;
//   const mediumRisk = safeArrearsData.filter(a => a.overdue_days > 30 && a.overdue_days <= 90).length;
//   const lowRisk = safeArrearsData.filter(a => a.overdue_days <= 30).length;

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Arrear Report</Typography>
//       <Box sx={{ textAlign: 'center', mb: 2 }}>
//         <Typography variant="h4" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
//         <Typography variant="caption">Total Outstanding</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 2 }}>
//         <Box sx={{ textAlign: 'center' }}>
//           <Typography variant="h6" color="#d32f2f">{highRisk}</Typography>
//           <Typography variant="caption">High Risk (&gt;90 days)</Typography>
//         </Box>
//         <Box sx={{ textAlign: 'center' }}>
//           <Typography variant="h6" color="#ff9800">{mediumRisk}</Typography>
//           <Typography variant="caption">Medium Risk (30-90 days)</Typography>
//         </Box>
//         <Box sx={{ textAlign: 'center' }}>
//           <Typography variant="h6" color="#4caf50">{lowRisk}</Typography>
//           <Typography variant="caption">Low Risk (&lt;30 days)</Typography>
//         </Box>
//       </Box>
//     </Card>
//   );
// };

// // ==================== COLLECTED REPORT CARD ====================
// const CollectedReportCard = ({ revenueData, arrearsData }) => {
//   // Ensure data is arrays
//   const safeRevenueData = Array.isArray(revenueData) ? revenueData : [];
//   const safeArrearsData = Array.isArray(arrearsData) ? arrearsData : [];
  
//   const totalInvoiced = safeRevenueData.reduce((sum, r) => sum + toNumber(r.amount), 0);
//   const totalOutstanding = safeArrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
//   const totalCollected = totalInvoiced - totalOutstanding;
//   const collectionRate = totalInvoiced > 0 ? (totalCollected / totalInvoiced) * 100 : 0;

//   const usdInvoiced = safeRevenueData.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((sum, r) => sum + toNumber(r.amount), 0);
//   const usdOutstanding = safeArrearsData.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((sum, a) => sum + toNumber(a.outstanding), 0);
//   const usdCollected = usdInvoiced - usdOutstanding;
//   const usdRate = usdInvoiced > 0 ? (usdCollected / usdInvoiced) * 100 : 0;

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Collected Report</Typography>
      
//       {/* Collection Rate Gauge */}
//       <Box sx={{ textAlign: 'center', mb: 2 }}>
//         <Box sx={{ position: 'relative', display: 'inline-block' }}>
//           <svg width={180} height={120} viewBox="0 0 180 120">
//             <path d="M 20 90 A 70 70 0 0 1 160 90" fill="none" stroke="#e0e0e0" strokeWidth="12" strokeLinecap="round" />
//             <path d={`M 20 90 A 70 70 0 ${collectionRate > 50 ? 1 : 0} 1 ${90 + 70 * Math.cos(Math.PI + (collectionRate * Math.PI) / 180)} ${90 + 70 * Math.sin(Math.PI + (collectionRate * Math.PI) / 180)}`} fill="none" stroke="#4caf50" strokeWidth="12" strokeLinecap="round" />
//             <text x={90} y={110} textAnchor="middle" fontSize="20" fontWeight="bold" fill="#4caf50">{collectionRate.toFixed(1)}%</text>
//           </svg>
//         </Box>
//         <Typography variant="caption">Overall Collection Rate</Typography>
//       </Box>

//       <Divider sx={{ my: 1 }} />

//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//         <Typography variant="caption" sx={{ fontWeight: 500 }}>Collected</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#4caf50">{formatCurrencyUSD(totalCollected)}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//         <Typography variant="caption" sx={{ fontWeight: 500 }}>Outstanding</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="caption" sx={{ fontWeight: 500 }}>USD Collection Rate</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#1976d2">{usdRate.toFixed(1)}%</Typography>
//       </Box>
//     </Card>
//   );
// };

// // ==================== FINANCIAL SUMMARY CARD ====================
// const FinancialSummaryCard = ({ revenueData, arrearsData, tradeData }) => {
//   // Ensure data is arrays
//   const safeRevenueData = Array.isArray(revenueData) ? revenueData : [];
//   const safeArrearsData = Array.isArray(arrearsData) ? arrearsData : [];
//   const safeTradeData = Array.isArray(tradeData) ? tradeData : [];
  
//   const totalRevenue = safeRevenueData.reduce((sum, r) => sum + toNumber(r.amount), 0);
//   const totalOutstanding = safeArrearsData.reduce((sum, a) => sum + toNumber(a.outstanding), 0);
//   const totalExport = safeTradeData.reduce((sum, t) => sum + toNumber(t.export_amount), 0);
//   const totalImport = safeTradeData.reduce((sum, t) => sum + toNumber(t.import_amount), 0);
//   const netTrade = totalExport - totalImport;

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Financial Summary</Typography>
      
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
//         <Typography variant="body2">Total Revenue:</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(totalRevenue)}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
//         <Typography variant="body2">Total Outstanding:</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(totalOutstanding)}</Typography>
//       </Box>
//       <Divider />
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1.5, mb: 1.5 }}>
//         <Typography variant="body2">Total Export:</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#1976d2">{formatCurrencyUSD(totalExport)}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
//         <Typography variant="body2">Total Import:</Typography>
//         <Typography variant="body2" fontWeight="bold" color="#ff9800">{formatCurrencyUSD(totalImport)}</Typography>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Typography variant="body2">Net Trade Balance:</Typography>
//         <Typography variant="body2" fontWeight="bold" color={netTrade >= 0 ? "#2e7d32" : "#d32f2f"}>{formatCurrencyUSD(Math.abs(netTrade))} {netTrade >= 0 ? "Surplus" : "Deficit"}</Typography>
//       </Box>
//     </Card>
//   );
// };

// // ==================== INVESTMENT BY INDUSTRY CARD ====================
// const InvestmentByIndustryCard = ({ investorsData }) => {
//   // Ensure investorsData is an array
//   const safeInvestorsData = Array.isArray(investorsData) ? investorsData : [];
  
//   const byIndustry = {};
//   safeInvestorsData.forEach(i => {
//     const industry = i.investment_type || "Other";
//     byIndustry[industry] = (byIndustry[industry] || 0) + 1;
//   });

//   const total = safeInvestorsData.length;
//   const colors = ['#1976d2', '#4caf50', '#ff9800', '#9c27b0', '#f44336'];

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investment by Industry</Typography>
//       {Object.entries(byIndustry).map(([industry, count], idx) => {
//         const percentage = total > 0 ? (count / total) * 100 : 0;
//         return (
//           <Box key={industry} sx={{ mb: 1.5 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//               <Typography variant="caption" sx={{ fontWeight: 500 }}>{industry}</Typography>
//               <Typography variant="caption">{count} ({percentage.toFixed(1)}%)</Typography>
//             </Box>
//             <LinearProgress variant="determinate" value={percentage} sx={{ height: 6, borderRadius: 3, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: colors[idx % colors.length] } }} />
//           </Box>
//         );
//       })}
//     </Card>
//   );
// };

// // ==================== INVESTOR ACTIVITY REPORT CARD ====================
// const InvestorActivityReportCard = ({ investorsData, contractsData }) => {
//   // Ensure data is arrays
//   const safeInvestorsData = Array.isArray(investorsData) ? investorsData : [];
//   const safeContractsData = Array.isArray(contractsData) ? contractsData : [];
  
//   const activeInvestors = safeInvestorsData.filter(i => i.status === "Active").length;
//   const newInvestors = 2; // Sample new investors in last 30 days
//   const expiringContracts = safeContractsData.filter(c => {
//     const endDate = new Date(c.end_date);
//     const today = new Date();
//     const daysRemaining = (endDate - today) / (1000 * 60 * 60 * 24);
//     return daysRemaining <= 90 && daysRemaining > 0;
//   }).length;

//   return (
//     <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
//       <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investor Activity Report</Typography>
//       <Grid container spacing={1}>
//         <Grid item xs={4}>
//           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
//             <Typography variant="h6" fontWeight="bold" color="#1976d2">{activeInvestors}</Typography>
//             <Typography variant="caption">Active</Typography>
//           </Box>
//         </Grid>
//         <Grid item xs={4}>
//           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
//             <Typography variant="h6" fontWeight="bold" color="#2e7d32">{newInvestors}</Typography>
//             <Typography variant="caption">New (30d)</Typography>
//           </Box>
//         </Grid>
//         <Grid item xs={4}>
//           <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
//             <Typography variant="h6" fontWeight="bold" color="#ff9800">{expiringContracts}</Typography>
//             <Typography variant="caption">Expiring Soon</Typography>
//           </Box>
//         </Grid>
//       </Grid>
//       <Divider sx={{ my: 1.5 }} />
//       <Typography variant="body2" fontWeight="bold" gutterBottom>Recent Activities:</Typography>
//       <Box sx={{ maxHeight: 100, overflowY: 'auto' }}>
//         <Typography variant="caption" display="block">• PVH Ethiopia - Contract Renewed (Jan 2024)</Typography>
//         <Typography variant="caption" display="block">• TAL Apparel - Expansion Approved (Feb 2024)</Typography>
//         <Typography variant="caption" display="block">• Huajian Group - New Lease Signed (Mar 2024)</Typography>
//       </Box>
//     </Card>
//   );
// };

// // ==================== MAIN DASHBOARD ====================
// export default function ParkPerformanceDashboard() {
//   const [selectedPark, setSelectedPark] = useState("all");
//   const [loading, setLoading] = useState(false);
//   const [activeCurrency, setActiveCurrency] = useState('usd');
//   const [parcelsData, setParcelsData] = useState([]);
//   const [shedsData, setShedsData] = useState([]);
//   const [parkIdin, setParkIdin]= useState();
//   const [revenueInPark, setRevenueInPark]= useState([]);
//   const [arrearInPark, setArrearInPark]= useState([]);
//   const [investorInPark, setInvestorInPark]= useState([]);
//   const [investorActivityInPark, setInvestorActivityInPark]= useState([]);
//   const [landUseInPark, setLandUseInPark]= useState([]);
//   const [occupavailInPark, setoccupavailInPark]= useState([]);

//   const decodedUser = useDecodedUser();

//   // ========== ADDED useEffect TO FETCH PARCELS BASED ON USER'S PARK ID ==========
//   useEffect(() => {
//     const fetchParcelsInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
//       setParkIdin(parkId)
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
//         console.log("Fetching parcels for park ID:", parkId);
        
//         const resultData = await GetParcelsInPark(parkId, false);
       
        
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) {
//           dataArray = resultData;
//         } else if (resultData?.data && Array.isArray(resultData.data)) {
//           dataArray = resultData.data;
//         }
        
//         const filteredParcel = dataArray?.map(({ geometry, ...rest }) => rest);
//         console.log("Filtered parcels count:", filteredParcel?.length);
        
//         if (filteredParcel && filteredParcel?.length > 0) {
//           setParcelsData(filteredParcel);
//           console.log("Parcels data set successfully");
//         } else {
//           setParcelsData([]);
//           console.log("No parcels found for this park");
//         }
        
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to fetch parcels data:", error);
//         setLoading(false);
//       }
//     };
//     const fetchshedsInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetShedsByPark (parkId, false);
//         console.log("SHEDDD:", resultData1);
//         setShedsData(resultData1);
               
//         let dataArray = [];
//         if (resultData1 && Array.isArray(resultData1)) {
//           dataArray2 = resultData1;
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           dataArray2 = resultData1.data;
//         }
        
//         let dataArray2 = [];
//         const filteredParcel = dataArray?.map(({ geometry, ...rest }) => rest);
//         console.log("Filtered parcels count:", filteredParcel?.length);
        
//         if (filteredParcel && filteredParcel?.length > 0) {
//           setParcelsData(filteredParcel);
//           console.log("Parcels data set successfully");
//         } else {
//           setParcelsData([]);
//           console.log("No parcels found for this park");
//         }

        
        
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to fetch parcels data:", error);
//         setLoading(false);
//       }
//     };
//     const fetchRevenueInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetRevenueByPark (parkId, false);
//         console.log("REVENUEEEEEEEEEEEEEEEEEEEEEEEE", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setRevenueInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setRevenueInPark(resultData1.data);
//         } else {
//           setRevenueInPark([]);
//         }
//         console.log("Parcels data set successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to fetch parcels data:", error);
//         setRevenueInPark([]);
//         setLoading(false);
//       }
//     };
//     const fetchArrearInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetArrearByPark (parkId, false);
//         console.log("ARREARRRRRRRRR", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setArrearInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setArrearInPark(resultData1.data);
//         } else {
//           setArrearInPark([]);
//         }
//         console.log("Parcels data set successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to arrear data:", error);
//         setArrearInPark([]);
//         setLoading(false);
//       }
//     };
//     const fetchInvestorInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetInvestorInPark (parkId, false);
//         console.log("investorRRRRRRRRRRRRRRRRr", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setInvestorInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setInvestorInPark(resultData1.data);
//         } else {
//           setInvestorInPark([]);
//         }
//         console.log("investor set successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to arrear data:", error);
//         setInvestorInPark([]);
//         setLoading(false);
//       }
//     };
//     const fetchInvestorActivityInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetInvestorsActivityByPark (parkId, false);
//         console.log("investor Activity", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setInvestorActivityInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setInvestorActivityInPark(resultData1.data);
//         } else {
//           setInvestorActivityInPark([]);
//         }
//         console.log("investor Activity successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to investor activity data:", error);
//         setInvestorActivityInPark([]);
//         setLoading(false);
//       }
//     };
//     const fetchLandUseInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetLandUseByPark (parkId, false);
//         console.log("Land Use", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setLandUseInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setLandUseInPark(resultData1.data);
//         } else {
//           setLandUseInPark([]);
//         }
//         console.log("Land Use successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to Land Use data:", error);
//         setLandUseInPark([]);
//         setLoading(false);
//       }
//     };
//     const fetchOccupiedAvailableInPark = async () => {
//       const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
//       if (!parkId) {
//         console.log("No park ID found for user:", decodedUser);
//         return;
//       }

//       try {
//         setLoading(true);
              
//         const resultData1 = await GetLandUseByPark (parkId, false);
//         console.log("Occupied Available parcel", resultData1);
//         // Ensure we set an array
//         if (Array.isArray(resultData1)) {
//           setoccupavailInPark(resultData1);
//         } else if (resultData1?.data && Array.isArray(resultData1.data)) {
//           setoccupavailInPark(resultData1.data);
//         } else {
//           setoccupavailInPark([]);
//         }
//         console.log("Occupied Available successfully");
            
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to Occupied Available data:", error);
//         setoccupavailInPark([]);
//         setLoading(false);
//       }
//     };
//     if (decodedUser) {
//       console.log("Land use data available, fetching parcels...");
//       fetchParcelsInPark();
//       fetchRevenueInPark();
//       fetchshedsInPark();
//       fetchArrearInPark();
//       fetchInvestorInPark (); 
//       fetchInvestorActivityInPark();
//       fetchLandUseInPark();
//       fetchOccupiedAvailableInPark()
//     } else {
//       console.log("Waiting for user data...");
//     }
//   }, [decodedUser]);
//   // ========== END OF ADDED useEffect ==========

//   // Filter data by park
//   const filteredRevenue = useMemo(() => {
//     return Array.isArray(revenueInPark) ? revenueInPark : [];
//   }, [revenueInPark]);

//   const filteredArrears = useMemo(() => {
//     return Array.isArray(arrearInPark) ? arrearInPark : [];
//   }, [arrearInPark]);

//   const filteredTrade = useMemo(() => {
//     if (selectedPark === "all") return SAMPLE_TRADE;
//     return SAMPLE_TRADE.filter(t => t.park_name.toLowerCase().includes(selectedPark.toLowerCase()));
//   }, [selectedPark]);

//  const filteredInvestors = useMemo(() => {
//   return Array.isArray(investorInPark) ? investorInPark : [];
// }, [investorInPark]); 

//   const filteredPotential = useMemo(() => {
//     if (selectedPark === "all") return SAMPLE_POTENTIAL_INVESTORS;
//     return SAMPLE_POTENTIAL_INVESTORS.filter(p => p.park_interested_in.toLowerCase().includes(selectedPark.toLowerCase()));
//   }, [selectedPark]);

//   const filteredContracts = useMemo(() => {
//     if (selectedPark === "all") return SAMPLE_CONTRACTS;
//     return SAMPLE_CONTRACTS.filter(c => c.park.toLowerCase().includes(selectedPark.toLowerCase()));
//   }, [selectedPark]);

//   // FIXED: Updated parkSummary useMemo with correct dependencies and park_id comparison
//   // const parkSummary = useMemo(() => {
//   //   // Filter parcels directly using parkIdin from the logged-in user
//   //   const parkParcels = parcelsData.filter(p => String(p.park_id) === String(parkIdin));
//   //   const occupiedParcels = parkParcels.filter(p => p.rental_lease_status === "Occupied").length;
//   //   // console.log("TOTALLLLLLL",occupiedParcels)
    
//   //   let totalParcelArea = 0;
//   //   if (parcelsData ) {
//   //     console.log("Park ID from user:", parkIdin);
//   //     console.log("Total parcels in park:", parkParcels.length);
//   //     totalParcelArea = parkParcels.reduce((sum, p) => sum + (p.area || 0), 0);
//   //     console.log("Total area:", totalParcelArea);
//   //   }
    
//   //   const occupiedArea = parkParcels.filter(p => p.rental_lease_status === "Occupied").reduce((sum, p) => sum + (p.area || 0), 0);
//   //   // For sheds - you might need to convert parkIdin to number if SAMPLE_SHEDS uses numbers
//   //   const parkSheds = shedsData.filter(s => String(s.park_id) === String(parkIdin));
//   //   const occupiedSheds = shedsData.filter(s => s.status_utilization === "Occupied").length;
//   //   console.log("SHEDDDDDDDDDDssss",occupiedSheds)
    
//   //   return {
//   //     occupancyRate: totalParcelArea > 0 ? (occupiedArea / totalParcelArea) * 100 : 0,
//   //     parcelRatio: parkParcels.length > 0 ? (occupiedParcels / parkParcels.length) * 100 : 0,
//   //     shedOccupancy: parkSheds.length > 0 ? (occupiedSheds / parkSheds.length) * 100 : 0,
//   //     totalArea: totalParcelArea, // You might want to get this from somewhere else or calculate from parcels
//   //     occupiedArea,
//   //     totalParcels: parkParcels.length,
//   //     occupiedParcels,
//   //     parkName: "" // You might want to get this from the user or API
//   //   };
//   // }, [parkIdin, parcelsData, shedsData]);// Keep dependencies as is// FIXED: Added selectedPark to dependencies and removed unused parkIdin
// //***************************************** parksummary updated */
// // FIXED: Updated parkSummary useMemo with safe array handling
// const parkSummary = useMemo(() => {
//   // Ensure shedsData is an array
//   const safeShedsData = Array.isArray(shedsData) ? shedsData : [];
//   const safeParcelsData = Array.isArray(parcelsData) ? parcelsData : [];
  
//   // Filter parcels directly using parkIdin from the logged-in user
//   const parkParcels = safeParcelsData.filter(p => String(p.park_id) === String(parkIdin));
//   const occupiedParcels = parkParcels.filter(p => p.rental_lease_status === "Occupied").length;
  
//   let totalParcelArea = 0;
//   if (safeParcelsData.length > 0) {
//     console.log("Park ID from user:", parkIdin);
//     console.log("Total parcels in park:", parkParcels.length);
//     totalParcelArea = parkParcels.reduce((sum, p) => sum + (p.area || 0), 0);
//     console.log("Total area:", totalParcelArea);
//   }
  
//   const occupiedArea = parkParcels.filter(p => p.rental_lease_status === "Occupied").reduce((sum, p) => sum + (p.area || 0), 0);
  
//   // For sheds - safe handling
//   const parkSheds = safeShedsData.filter(s => String(s.park_id) === String(parkIdin));
//   const occupiedSheds = safeShedsData.filter(s => s.status_utilization === "Occupied").length;
//   console.log("SHEDDDDDDDDDDssss", occupiedSheds);
  
//   return {
//     occupancyRate: totalParcelArea > 0 ? (occupiedArea / totalParcelArea) * 100 : 0,
//     parcelRatio: parkParcels.length > 0 ? (occupiedParcels / parkParcels.length) * 100 : 0,
//     shedOccupancy: parkSheds.length > 0 ? (occupiedSheds / parkSheds.length) * 100 : 0,
//     totalArea: totalParcelArea,
//     occupiedArea,
//     totalParcels: parkParcels.length,
//     occupiedParcels,
//     parkName: ""
//   };
// }, [parkIdin, parcelsData, shedsData]);
//   // Revenue by park for charts
//   const revenueByPark = useMemo(() => {
//     const map = {};
//     SAMPLE_REVENUE.forEach(r => {
//       map[r.park_name] = (map[r.park_name] || 0) + (r.amount || 0);
//     });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
//   }, []);

//   const outstandingByPark = useMemo(() => {
//     const map = {};
//     SAMPLE_ARREARS.forEach(a => {
//       map[a.park_name] = (map[a.park_name] || 0) + (a.outstanding || 0);
//     });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
//   }, []);

//   const investmentByType = useMemo(() => {
//     const map = {};
//     SAMPLE_INVESTORS.forEach(i => {
//       const type = i.investment_type || "Other";
//       map[type] = (map[type] || 0) + 1;
//     });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
//   }, []);

//   const topSectors = useMemo(() => {
//     const map = {};
//     SAMPLE_POTENTIAL_INVESTORS.forEach(p => {
//       const sector = p.sector_of_interest || "Other";
//       map[sector] = (map[sector] || 0) + 1;
//     });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
//   }, []);

//   const topParksInterest = useMemo(() => {
//     const map = {};
//     SAMPLE_POTENTIAL_INVESTORS.forEach(p => {
//       const park = p.park_interested_in || "Other";
//       map[park] = (map[park] || 0) + 1;
//     });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
//   }, []);
// {console.log("LAND USEEEEEEEEEE", landUseInPark)}
// const landUseData = useMemo(() => {
//   // Safety check - if data hasn't loaded yet, return zeros
//   console.log("LandUseInPark data:", landUseInPark);
  
//   if (!landUseInPark || !Array.isArray(landUseInPark) || landUseInPark.length === 0) {
//     return { 'Parcels': 0, 'Green Areas': 0, 'Roads': 0 };
//   }
  
//   // Handle different possible data structures
//   let totalArea = 0;
//   let availableArea = 0;
//   let holdArea = 0;
  
//   // If it's an array with at least one item
//   if (Array.isArray(landUseInPark) && landUseInPark.length > 0) {
//     totalArea = landUseInPark[0].totalarea || landUseInPark[0].total_area || 0;
//     availableArea = landUseInPark[0].availablearea || landUseInPark[0].available_area || 0;
//     holdArea = landUseInPark[0].holdarea || landUseInPark[0].hold_area || 0;
//   } 
//   // If it's a single object
//   else if (typeof landUseInPark === 'object' && !Array.isArray(landUseInPark)) {
//     totalArea = landUseInPark.totalarea || landUseInPark.total_area || 0;
//     availableArea = landUseInPark.availablearea || landUseInPark.available_area || 0;
//     holdArea = landUseInPark.holdarea || landUseInPark.hold_area || 0;
//   }
  
//   console.log("Processed land use data:", { totalArea, availableArea, holdArea });
  
//   return { 
//     'Total Area': totalArea, 
//     'Available Area': availableArea, 
//     'Hold Area': holdArea 
//   };
// }, [landUseInPark]);// ← Changed dependency from parcelsData to landUseInPark


// // Add safety check for investorActivityInPark when calculating totals
// const totalEmployees = useMemo(() => {
//   if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) return 0;
  
//   // Create a Map to store the latest record for each investor_id
//   const latestRecordsMap = new Map();
  
//   investorActivityInPark.forEach(record => {
//     const investorId = record.investor_id;
//     const currentDate = new Date(record.recorded_on);
    
//     if (!latestRecordsMap.has(investorId)) {
//       // First record for this investor
//       latestRecordsMap.set(investorId, record);
//     } else {
//       // Compare dates and keep the latest
//       const existingRecord = latestRecordsMap.get(investorId);
//       const existingDate = new Date(existingRecord.recorded_on);
      
//       if (currentDate > existingDate) {
//         latestRecordsMap.set(investorId, record);
//       }
//     }
//   });
  
//   // Sum up the latest records
//   const latestRecords = Array.from(latestRecordsMap.values());
  
//   return latestRecords.reduce((sum, e) => {
//     const laborFemale = toNumber(e.emp_labor_female);
//     const laborMale = toNumber(e.emp_labor_male);
//     const profFemale = toNumber(e.emp_prof_female);
//     const profMale = toNumber(e.emp_prof_male);
//     return sum + laborFemale + laborMale + profFemale + profMale;
//   }, 0);
// }, [investorActivityInPark]);


// const totalExport = useMemo(() => {
//   if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) return 0;
//   return investorActivityInPark.reduce((sum, t) => sum + toNumber(t.export_amount), 0);
// }, [investorActivityInPark]);

// const totalImport = useMemo(() => {
//   if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) return 0;
//   return investorActivityInPark.reduce((sum, t) => sum + toNumber(t.import_substitution), 0);
// }, [investorActivityInPark]);

//   // const totalEmployees = investorActivityInPark.reduce((sum, e) => sum + (e.emp_labor_female + e.emp_labor_male + e.emp_prof_female + e.emp_prof_male), 0);
//   // const totalExport = investorActivityInPark.reduce((sum, t) => sum + t.export_amount, 0);
//   // const totalImport = investorActivityInPark.reduce((sum, t) => sum + t.import_amount, 0);
//   // const totalInvestors = SAMPLE_INVESTORS.length;
//   // const totalPotential = SAMPLE_POTENTIAL_INVESTORS.length;
//   // const convertedCount = SAMPLE_POTENTIAL_INVESTORS.filter(pot => SAMPLE_INVESTORS.some(inv => inv.email === pot.email)).length;
//   // const conversionRate = totalPotential > 0 ? (convertedCount / totalPotential) * 100 : 0;
//   // const totalCapital = SAMPLE_INVESTORS.reduce((sum, i) => sum + i.capital, 0);

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress /><Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ bgcolor: '#f4f9ff', width: '100%', mx: 0, py: 1 }}>
//       {/* Header */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
          
//            <Grid item xs={12} md={12}>
//           <IPDCWelcomeMessage messageTitle="Park Staff" />
//         </Grid>
//           </Typography>
//           {/* <FormControl sx={{ minWidth: 200 }} size="small">
//             <InputLabel>Select Park</InputLabel>
//             <Select value={selectedPark} onChange={(e) => setSelectedPark(e.target.value)} label="Select Park">
//               <MenuItem value="all">All Parks</MenuItem>
//               {SAMPLE_PARKS.map(park => (
//                 <MenuItem key={park.id} value={park.name.toLowerCase()}>{park.name}</MenuItem>
//               ))}
//             </Select>
//           </FormControl> */}
//         </Box>
//       </Container>

    

//       {/* Bold Line Separator */}
//       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>

//       {/* ========== SECTION 2: KEY METRICS ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//           <AssessmentIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Key Performance Metrics</Typography>
//         </Box>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6} md={4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Occupancy Rate</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.occupancyRate)}</Typography>
//               <ProgressBarCell value={parkSummary.occupancyRate} label="Occupancy" />
//             </Card>
//           </Grid>
//           {/* <Grid item xs={12} sm={6} md={3}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Parcel Ratio</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.parcelRatio)}</Typography>
//               <ProgressBarCell value={parkSummary.parcelRatio} label="Parcel" color="#1976d2" />
//             </Card>
//           </Grid> */}
//           <Grid item xs={12} sm={6} md={4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Shed Occupancy</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.shedOccupancy)}</Typography>
//               <ProgressBarCell value={parkSummary.shedOccupancy} label="Shed" color="#795548" />
//             </Card>
//           </Grid>
//           <Grid item xs={12} sm={6} md={4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Area</Typography>
//               <Typography variant="h5" fontWeight="bold">{parkSummary.totalArea.toFixed(1)} m²</Typography>
//               <Typography variant="caption" color="textSecondary">Occupied: {parkSummary.occupiedArea.toFixed(1)}m²</Typography>
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Bold Line Separator */}
//       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>

//       {/* ========== SECTION 3: REPORTS ROW 1 ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={4}>
         
//             <QuarterlyReportCard revenueData={filteredRevenue} arrearsData={filteredArrears} />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <InvestorSummaryCard investorsData={filteredInvestors} potentialInvestors={filteredPotential} />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <InvestmentByIndustryCard investorsData={filteredInvestors} />
//           </Grid>
//         </Grid>
//       </Container>

//       {/* ========== SECTION 4: REPORTS ROW 2 ========== */}   

//       {/* Bold Line Separator */}
//       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>

//       {/* ========== SECTION 5: FINANCIAL ANALYTICS ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//           <BarChartIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Investor Activities</Typography>
//         </Box>

//         {/* KPI Cards */}
//         <Grid container spacing={2} sx={{ mb: 3 }}>
//   <Grid item xs={12} sm={6} md={3}>
//     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
//       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Revenue</Typography>
      
//       <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
//         {/* USD Revenue */}
//         <Box>
//           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
//           <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
//             {formatCurrencyUSD(
//               filteredRevenue
//                 .filter(r => r.payment_mode?.toLowerCase() === "usd")
//                 .reduce((s, r) => s + toNumber(r.amount), 0)
//             )}
//           </Typography>
//         </Box>
        
//         <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        
//         {/* Birr Revenue */}
//         <Box>
//           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
//           <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
//             {formatCurrencyETB(
//               filteredRevenue
//                 .filter(r => r.payment_mode?.toLowerCase() === "birr" || r.payment_mode?.toLowerCase() === "etb")
//                 .reduce((s, r) => s + toNumber(r.amount), 0)
//             )}
//           </Typography>
//         </Box>
//       </Box>
//     </Card>
//   </Grid>
  
//   <Grid item xs={12} sm={6} md={3}>
//     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
//       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Outstanding</Typography>
      
//       <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
//         {/* USD Outstanding */}
//         <Box>
//           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
//           <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
//             {formatCurrencyUSD(
//               filteredArrears
//                 .filter(a => a.payment_mode?.toLowerCase() === "usd")
//                 .reduce((s, a) => s + toNumber(a.outstanding), 0)
//             )}
//           </Typography>
//         </Box>
        
//         <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        
//         {/* Birr Outstanding */}
//         <Box>
//           <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
//           <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
//             {formatCurrencyETB(
//               filteredArrears
//                 .filter(a => a.payment_mode?.toLowerCase() === "birr" || a.payment_mode?.toLowerCase() === "etb")
//                 .reduce((s, a) => s + toNumber(a.outstanding), 0)
//             )}
//           </Typography>
//         </Box>
//       </Box>
//     </Card>
//   </Grid>
  
//   <Grid item xs={12} sm={6} md={3}>
//     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Export</Typography>
//       <Typography variant="h6" fontWeight="bold" color="#1976d2" sx={{ mt: 1 }}>
//         {formatCurrencyUSD(totalExport)}
//       </Typography>
//     </Card>
//   </Grid>
  
//   <Grid item xs={12} sm={6} md={3}>
//     <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//       <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Employees</Typography>
//       <Typography variant="h6" fontWeight="bold" sx={{ mt: 1 }}>
//         {formatNumber(totalEmployees)}
//       </Typography>
//     </Card>
//   </Grid>
// </Grid>
//         {/* Charts */}
        
//       </Container>

//       {/* Bold Line Separator */}
//       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>

//       {/* ========== SECTION 6: LAND USE & INVESTMENT ========== */}

//       {console.log("KOKOKOKOKOKOK",landUseData)}
//      {/* ========== SECTION 6: LAND USE & INVESTMENT ========== */}

// {console.log("KOKOKOKOKOKOK", landUseData)}
// {console.log("Occupancy Availability Data:", occupavailInPark)}

// <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
//   <Grid container spacing={2}>
//     <Grid item xs={12} md={6}>
//       <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
//         <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
//           Land Use Proportion
//         </Typography>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
//           <Box sx={{ position: 'relative', width: 180, height: 180 }}>
//             <svg width={180} height={180} viewBox="0 0 180 180">
//               {(() => {
//                 const items = Object.keys(landUseData);
//                 const total = items.reduce((sum, key) => sum + landUseData[key], 0);
//                 const colors = ['#1976d2', '#4caf50', '#ff9800'];
//                 let startAngle = 0;
//                 const centerX = 90, centerY = 90, radius = 70;
//                 return items.map((key, index) => {
//                   const value = landUseData[key];
//                   const percentage = total > 0 ? (value / total) * 100 : 0;
//                   const angle = (percentage / 100) * 360;
//                   const endAngle = startAngle + angle;
//                   const startRad = (startAngle * Math.PI) / 180;
//                   const endRad = (endAngle * Math.PI) / 180;
//                   const x1 = centerX + radius * Math.cos(startRad);
//                   const y1 = centerY + radius * Math.sin(startRad);
//                   const x2 = centerX + radius * Math.cos(endRad);
//                   const y2 = centerY + radius * Math.sin(endRad);
//                   const largeArcFlag = angle > 180 ? 1 : 0;
//                   const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
//                   startAngle = endAngle;
//                   return <path key={key} d={pathData} fill={colors[index]} stroke="white" strokeWidth="2" />;
//                 });
//               })()}
//               <circle cx={90} cy={90} r="35" fill="white" />
//               <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
//               <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
//                 {formatNumber(Object.values(landUseData).reduce((a, b) => a + b, 0))} m²
//               </text>
//             </svg>
//           </Box>
//           <Box>
//             {Object.entries(landUseData).map(([key, value], idx) => {
//               const total = Object.values(landUseData).reduce((a, b) => a + b, 0);
//               const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
//               const colors = ['#1976d2', '#4caf50', '#ff9800'];
//               return (
//                 <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Box sx={{ width: 12, height: 12, bgcolor: colors[idx], borderRadius: 1 }} />
//                   <Typography variant="caption">
//                     {key}: {value.toFixed(1)} m² ({percentage}%)
//                   </Typography>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       </Box>
//     </Grid>
    
//     {/* New: Land Occupancy Status Chart */}
//     <Grid item xs={12} md={6}>
//       <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
//         <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
//           Land Occupancy Status
//         </Typography>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
//           <Box sx={{ position: 'relative', width: 180, height: 180 }}>
//             <svg width={180} height={180} viewBox="0 0 180 180">
//               {(() => {
//                 // Prepare occupancy data
//                 let occupancyData = {};
//                 if (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0) {
//                   occupancyData = {
//                     'Available': occupavailInPark[0].availablearea || occupavailInPark[0].availableArea || 0,
//                     'Hold': occupavailInPark[0].holdarea || occupavailInPark[0].holdArea || 0
//                   };
//                 } else if (occupavailInPark && typeof occupavailInPark === 'object' && !Array.isArray(occupavailInPark)) {
//                   occupancyData = {
//                     'Available': occupavailInPark.availablearea || occupavailInPark.availableArea || 0,
//                     'Hold': occupavailInPark.holdarea || occupavailInPark.holdArea || 0
//                   };
//                 }
                
//                 const items = Object.keys(occupancyData);
//                 const total = items.reduce((sum, key) => sum + occupancyData[key], 0);
//                 const colors = ['#4caf50', '#ff9800', '#f44336'];
//                 let startAngle = 0;
//                 const centerX = 90, centerY = 90, radius = 70;
                
//                 if (items.length === 0 || total === 0) {
//                   return (
//                     <text x={90} y={90} textAnchor="middle" fontSize="4" fill="#999">
//                       No data available
//                     </text>
//                   );
//                 }
                
//                 return items.map((key, index) => {
//                   const value = occupancyData[key];
//                   const percentage = total > 0 ? (value / total) * 100 : 0;
//                   const angle = (percentage / 100) * 360;
//                   const endAngle = startAngle + angle;
//                   const startRad = (startAngle * Math.PI) / 180;
//                   const endRad = (endAngle * Math.PI) / 180;
//                   const x1 = centerX + radius * Math.cos(startRad);
//                   const y1 = centerY + radius * Math.sin(startRad);
//                   const x2 = centerX + radius * Math.cos(endRad);
//                   const y2 = centerY + radius * Math.sin(endRad);
//                   const largeArcFlag = angle > 180 ? 1 : 0;
//                   const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
//                   startAngle = endAngle;
//                   return <path key={key} d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="2" />;
//                 });
//               })()}
//               <circle cx={90} cy={90} r="35" fill="white" />
//               <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
//               <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
//                 {formatNumber(
//                   (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0)
//                     ? (occupavailInPark[0].totalarea || occupavailInPark[0].totalArea || 0)
//                     : (occupavailInPark?.totalarea || occupavailInPark?.totalArea || 0)
//                 )} m²
//               </text>
//             </svg>
//           </Box>
//           <Box>
//             {(() => {
//               let occupancyData = {};
//               if (occupavailInPark && Array.isArray(occupavailInPark) && occupavailInPark.length > 0) {
//                 occupancyData = {
//                   'Available': occupavailInPark[0].availablearea || occupavailInPark[0].availableArea || 0,
//                   'Hold': occupavailInPark[0].holdarea || occupavailInPark[0].holdArea || 0
//                 };
//               } else if (occupavailInPark && typeof occupavailInPark === 'object' && !Array.isArray(occupavailInPark)) {
//                 occupancyData = {
//                   'Available': occupavailInPark.availablearea || occupavailInPark.availableArea || 0,
//                   'Hold': occupavailInPark.holdarea || occupavailInPark.holdArea || 0
//                 };
//               }
              
//               const total = Object.values(occupancyData).reduce((a, b) => a + b, 0);
//               const colors = ['#4caf50', '#ff9800', '#f44336'];
              
//               return Object.entries(occupancyData).map(([key, value], idx) => {
//                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
//                 return (
//                   <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <Box sx={{ width: 12, height: 12, bgcolor: colors[idx % colors.length], borderRadius: 1 }} />
//                     <Typography variant="caption">
//                       {key}: {value.toFixed(1)} m² ({percentage}%)
//                     </Typography>
//                   </Box>
//                 );
//               });
//             })()}
//           </Box>
//         </Box>
//       </Box>
//     </Grid>
//   </Grid>
// </Container>

//       {/* Bold Line Separator */}
//       <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>

//       {/* ========== SECTION 7: PROMOTION & MARKETING ========== */}
      
//     </Box>
//   );
// }
//********************************************************************* */
import { useEffect, useState, useMemo, useCallback } from "react";
import { IPDCWelcomeMessage } from "../../../components";
import { GetParcelsInPark,
  GetShedsByPark, 
  GetRevenueByPark,
  GetArrearByPark,
  GetInvestorInPark,
  GetInvestorsActivityByPark,
  GetOccuAvaByPark,
  GetLandUseByPark   } from "../../Views/Shared/CommonData/CommonData";
import useDecodedUser from "../../../services/hooks/useDecodedUser";
import {
  ParksBySectorCard,
  ParksByOccupancyCard,
  HandoverCard,
 } from "../Shared/DashboardCards";
import LandUseProportionCard from '../LandInfraDevelopment/Head/DashboardDetail/LandUseProportionCard.jsx';
import ShedParcelRatioCard from '../LandInfraDevelopment/Head/DashboardDetail/ShedParcelRatioCard.jsx';

import {
  Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
  Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
  FormControl, InputLabel, Select, IconButton, CircularProgress,
  ToggleButton, ToggleButtonGroup, Alert
} from "@mui/material";
import {
  Business as BusinessIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  WarningAmber as WarningIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  AttachMoney as MoneyIcon,
  Assessment as AssessmentIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  Download as DownloadIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  ShowChart as ShowChartIcon,
  People as PeopleIcon,
  LocationOn as LocationOnIcon,
  CheckCircle as CheckCircleIcon,
  Warehouse as WarehouseIcon,
  ViewModule as ViewModuleIcon,
  Straighten as StraightenIcon,
  Home as HomeIcon,
  Agriculture as AgricultureIcon,
  Map as MapIcon
} from "@mui/icons-material";

// ==================== HELPER FUNCTIONS ====================
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    // Remove commas, dollar signs, currency symbols, and spaces
    const cleaned = value.replace(/[$,]/g, '').trim();
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }
  if (value === null || value === undefined) return 0;
  return 0;
};

const formatNumber = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  return new Intl.NumberFormat('en-US').format(num);
};

const formatCurrencyUSD = (amount) => {
  const num = toNumber(amount);
  if (num === 0) return "$0";
  return `$${formatNumber(num)}`;
};

const formatCurrencyETB = (amount) => {
  const num = toNumber(amount);
  if (num === 0) return "0 ETB";
  return `${formatNumber(num)} ETB`;
};

const formatPercentage = (value) => {
  const num = toNumber(value);
  if (num === 0) return "0%";
  return `${num.toFixed(1)}%`;
};

const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "birr";
  return mode;
};

// ==================== PROGRESS BAR COMPONENT ====================
const ProgressBarCell = ({ value, label, color }) => {
  const percentage = Math.min(100, Math.max(0, toNumber(value)));
  const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
  return (
    <Box sx={{ minWidth: 80 }}>
      <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
            <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
              {formatPercentage(percentage)}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: 5, borderRadius: 2.5, backgroundColor: '#e0e0e0',
              '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

// ==================== QUARTERLY REPORT CARD ====================
const QuarterlyReportCard = ({ revenueData, arrearsData }) => {
  const safeRevenueData = Array.isArray(revenueData) ? revenueData : [];
  const safeArrearsData = Array.isArray(arrearsData) ? arrearsData : [];
  
  const currentYear = new Date().getFullYear();

  const quarters = [
    { label: `Q1 ${currentYear}`, months: ["01", "02", "03"] },
    { label: `Q2 ${currentYear}`, months: ["04", "05", "06"] },
    { label: `Q3 ${currentYear}`, months: ["07", "08", "09"] },
    { label: `Q4 ${currentYear}`, months: ["10", "11", "12"] }
  ];
 
  const quarterData = quarters.map(q => {
    const revenueUSD = safeRevenueData
      .filter(r => q.months.includes(r.month) && 
                   String(r.year) === String(currentYear) && 
                   normalizeCurrency(r.payment_mode) === "usd")
      .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
    const revenueBirr = safeRevenueData
      .filter(r => q.months.includes(r.month) && 
                   String(r.year) === String(currentYear) && 
                   normalizeCurrency(r.payment_mode) === "birr")
      .reduce((sum, r) => sum + toNumber(r.amount), 0);
    
    const outstandingUSD = safeArrearsData
      .filter(a => normalizeCurrency(a.payment_mode) === "usd")
      .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
    
    const outstandingBirr = safeArrearsData
      .filter(a => normalizeCurrency(a.payment_mode) === "birr")
      .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
   
    return { 
      label: q.label, 
      revenueUSD, 
      revenueBirr,
      outstandingUSD,
      outstandingBirr
    };
  });

  return (
    <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
      <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Quarterly Report</Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', gap: 2, minWidth: 600 }}>
          {quarterData.map((q, idx) => (
            <Box key={idx} sx={{ flex: 1, textAlign: 'center', p: 1, bgcolor: 'white', borderRadius: 1 }}>
              <Typography variant="body2" fontWeight="bold">{q.label}</Typography>
              
              <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>USD</Typography>
              <Typography variant="caption" color="textSecondary">Revenue</Typography>
              <Typography variant="body2" color="green">{formatCurrencyUSD(q.revenueUSD)}</Typography>
              <Typography variant="caption" color="textSecondary">Outstanding</Typography>
              <Typography variant="body2" color="red">{formatCurrencyUSD(q.outstandingUSD)}</Typography>
              
              <Divider sx={{ my: 1 }} />
              
              <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>BIRR</Typography>
              <Typography variant="caption" color="textSecondary">Revenue</Typography>
              <Typography variant="body2" color="green">{formatCurrencyETB(q.revenueBirr)}</Typography>
              <Typography variant="caption" color="textSecondary">Outstanding</Typography>
              <Typography variant="body2" color="red">{formatCurrencyETB(q.outstandingBirr)}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

// ==================== INVESTOR SUMMARY CARD ====================
const InvestorSummaryCard = ({ investorsData, potentialInvestors }) => {
  const safeInvestorsData = Array.isArray(investorsData) ? investorsData : [];
  
  const activeInvestors = safeInvestorsData.filter(i => i.status === "active" || i.status === "Operational" || i.status === "Active").length;
  const byNationality = {};
  safeInvestorsData.forEach(i => {
    const country = i.nationality_origin || "Unknown";
    byNationality[country] = (byNationality[country] || 0) + 1;
  });

  return (
    <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
      <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investor Summary</Typography>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
            <Typography variant="h5" fontWeight="bold" color="#1976d2">{safeInvestorsData.length}</Typography>
            <Typography variant="caption">Total Investors</Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ textAlign: 'center', p: 1, bgcolor: '#e8f5e9', borderRadius: 1 }}>
            <Typography variant="h5" fontWeight="bold" color="#2e7d32">{activeInvestors}</Typography>
            <Typography variant="caption">Active Investors</Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <Typography variant="body2" fontWeight="bold" gutterBottom>By Nationality:</Typography>
          {Object.entries(byNationality).slice(0, 4).map(([country, count]) => (
            <Box key={country} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption">{country}</Typography>
              <Typography variant="caption" fontWeight="bold">{count}</Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};

// ==================== INVESTMENT BY INDUSTRY CARD ====================
const InvestmentByIndustryCard = ({ investorsData }) => {
  const safeInvestorsData = Array.isArray(investorsData) ? investorsData : [];
  
  const byIndustry = {};
  safeInvestorsData.forEach(i => {
    const industry = i.investment_type || "Other";
    byIndustry[industry] = (byIndustry[industry] || 0) + 1;
  });

  const total = safeInvestorsData.length;
  const colors = ['#1976d2', '#4caf50', '#ff9800', '#9c27b0', '#f44336'];

  return (
    <Card sx={{ p: 2, bgcolor: '#f5f5f5', height: '100%' }}>
      <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, fontWeight: 'bold' }}>Investment by Industry</Typography>
      {Object.entries(byIndustry).map(([industry, count], idx) => {
        const percentage = total > 0 ? (count / total) * 100 : 0;
        return (
          <Box key={industry} sx={{ mb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" sx={{ fontWeight: 500 }}>{industry}</Typography>
              <Typography variant="caption">{count} ({percentage.toFixed(1)}%)</Typography>
            </Box>
            <LinearProgress variant="determinate" value={percentage} sx={{ height: 6, borderRadius: 3, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: colors[idx % colors.length] } }} />
          </Box>
        );
      })}
    </Card>
  );
};

// ==================== MAIN DASHBOARD ====================
export default function ParkPerformanceDashboard() {
  const [selectedPark, setSelectedPark] = useState("all");
  const [loading, setLoading] = useState(false);
  const [activeCurrency, setActiveCurrency] = useState('usd');
  const [parcelsData, setParcelsData] = useState([]);
  const [shedsData, setShedsData] = useState([]);
  const [parkIdin, setParkIdin]= useState();
  const [revenueInPark, setRevenueInPark]= useState([]);
  const [arrearInPark, setArrearInPark]= useState([]);
  const [investorInPark, setInvestorInPark]= useState([]);
  const [investorActivityInPark, setInvestorActivityInPark]= useState([]);
  const [landUseInPark, setLandUseInPark]= useState([]);
  const [occupavailInPark, setoccupavailInPark]= useState([]);

  const decodedUser = useDecodedUser();

  // ========== FETCH DATA BASED ON USER'S PARK ID ==========
  useEffect(() => {
    const fetchParcelsInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
      setParkIdin(parkId)
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
        console.log("Fetching parcels for park ID:", parkId);
        
        const resultData = await GetParcelsInPark(parkId, false);
       
        let dataArray = [];
        if (resultData && Array.isArray(resultData)) {
          dataArray = resultData;
        } else if (resultData?.data && Array.isArray(resultData.data)) {
          dataArray = resultData.data;
        }
        
        const filteredParcel = dataArray?.map(({ geometry, ...rest }) => rest);
        console.log("Filtered parcels count:", filteredParcel?.length);
        
        if (filteredParcel && filteredParcel?.length > 0) {
          setParcelsData(filteredParcel);
          console.log("Parcels data set successfully");
        } else {
          setParcelsData([]);
          console.log("No parcels found for this park");
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch parcels data:", error);
        setLoading(false);
      }
    };
    const fetchshedsInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetShedsByPark (parkId, false);
        console.log("SHEDDD:", resultData1);
        if (Array.isArray(resultData1)) {
          setShedsData(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setShedsData(resultData1.data);
        } else {
          setShedsData([]);
        }
              
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch sheds data:", error);
        setShedsData([]);
        setLoading(false);
      }
    };
    const fetchRevenueInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetRevenueByPark (parkId, false);
        console.log("REVENUEEEEEEEEEEEEEEEEEEEEEEEE", resultData1);
        if (Array.isArray(resultData1)) {
          setRevenueInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setRevenueInPark(resultData1.data);
        } else {
          setRevenueInPark([]);
        }
        console.log("Revenue data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch revenue data:", error);
        setRevenueInPark([]);
        setLoading(false);
      }
    };
    const fetchArrearInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetArrearByPark (parkId, false);
        console.log("ARREARRRRRRRRR", resultData1);
        if (Array.isArray(resultData1)) {
          setArrearInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setArrearInPark(resultData1.data);
        } else {
          setArrearInPark([]);
        }
        console.log("Arrear data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to arrear data:", error);
        setArrearInPark([]);
        setLoading(false);
      }
    };
    const fetchInvestorInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetInvestorInPark (parkId, false);
        console.log("investorRRRRRRRRRRRRRRRRr", resultData1);
        if (Array.isArray(resultData1)) {
          setInvestorInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setInvestorInPark(resultData1.data);
        } else {
          setInvestorInPark([]);
        }
        console.log("Investor data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to investor data:", error);
        setInvestorInPark([]);
        setLoading(false);
      }
    };
    const fetchInvestorActivityInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetInvestorsActivityByPark (parkId, false);
        console.log("investor Activity", resultData1);
        if (Array.isArray(resultData1)) {
          setInvestorActivityInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setInvestorActivityInPark(resultData1.data);
        } else {
          setInvestorActivityInPark([]);
        }
        console.log("Investor Activity data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to investor activity data:", error);
        setInvestorActivityInPark([]);
        setLoading(false);
      }
    };
    const fetchLandUseInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetLandUseByPark (parkId, false);
        console.log("Land Use", resultData1);
        if (Array.isArray(resultData1)) {
          setLandUseInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setLandUseInPark(resultData1.data);
        } else {
          setLandUseInPark([]);
        }
        console.log("Land Use data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to Land Use data:", error);
        setLandUseInPark([]);
        setLoading(false);
      }
    };
    const fetchOccupiedAvailableInPark = async () => {
      const parkId = decodedUser?.park_id || decodedUser?.id || decodedUser?.parkId;
    
      if (!parkId) {
        console.log("No park ID found for user:", decodedUser);
        return;
      }

      try {
        setLoading(true);
              
        const resultData1 = await GetOccuAvaByPark (parkId, false);
        console.log("Occupied Available parcel", resultData1);
        if (Array.isArray(resultData1)) {
          setoccupavailInPark(resultData1);
        } else if (resultData1?.data && Array.isArray(resultData1.data)) {
          setoccupavailInPark(resultData1.data);
        } else {
          setoccupavailInPark([]);
        }
        console.log("Occupied Available data set successfully");
            
        setLoading(false);
      } catch (error) {
        console.error("Failed to Occupied Available data:", error);
        setoccupavailInPark([]);
        setLoading(false);
      }
    };
    if (decodedUser) {
      console.log("User data available, fetching data...");
      fetchParcelsInPark();
      fetchRevenueInPark();
      fetchshedsInPark();
      fetchArrearInPark();
      fetchInvestorInPark (); 
      fetchInvestorActivityInPark();
      fetchLandUseInPark();
      fetchOccupiedAvailableInPark()
    } else {
      console.log("Waiting for user data...");
    }
  }, [decodedUser]);

  // Filter data by park
  const filteredRevenue = useMemo(() => {
    return Array.isArray(revenueInPark) ? revenueInPark : [];
  }, [revenueInPark]);

  const filteredArrears = useMemo(() => {
    return Array.isArray(arrearInPark) ? arrearInPark : [];
  }, [arrearInPark]);

  const filteredInvestors = useMemo(() => {
    return Array.isArray(investorInPark) ? investorInPark : [];
  }, [investorInPark]);

  // ==================== FIXED: Total Export Calculation ====================
  const totalExport = useMemo(() => {
    if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) {
      console.log("No investor activity data available for export");
      return 0;
    }
    const total = investorActivityInPark.reduce((sum, t) => {
      const amount = toNumber(t.export_amount);
      console.log("Export amount:", t.export_amount, "Parsed:", amount);
      return sum + amount;
    }, 0);
    console.log("Total Export:", total);
    return total;
  }, [investorActivityInPark]);

  // ==================== FIXED: Total Employees Calculation ====================
  // const totalEmployees = useMemo(() => {
  //   if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) {
  //     console.log("No investor activity data available for employees");
  //     return 0;
  //   }
    
  //   // Create a Map to store the latest record for each investor_id
  //   const latestRecordsMap = new Map();
    
  //   investorActivityInPark.forEach(record => {
  //     const investorId = record.investor_id;
  //     // Use activity_period_to if available, otherwise recorded_on
  //     const currentDate = new Date(record.activity_period_to || record.recorded_on);
      
  //     if (!latestRecordsMap.has(investorId)) {
  //       latestRecordsMap.set(investorId, record);
  //     } else {
  //       const existingRecord = latestRecordsMap.get(investorId);
  //       const existingDate = new Date(existingRecord.activity_period_to || existingRecord.recorded_on);
        
  //       if (currentDate > existingDate) {
  //         latestRecordsMap.set(investorId, record);
  //       }
  //     }
  //   });
    
  //   const latestRecords = Array.from(latestRecordsMap.values());
  //   console.log("Latest records per investor:", latestRecords);
    
  //   const total = latestRecords.reduce((sum, e) => {
  //     const laborFemale = toNumber(e.emp_labor_female);
  //     const laborMale = toNumber(e.emp_labor_male);
  //     const profFemale = toNumber(e.emp_prof_female);
  //     const profMale = toNumber(e.emp_prof_male);
  //     const totalForRecord = laborFemale + laborMale + profFemale + profMale;
  //     console.log("Record employment:", { laborFemale, laborMale, profFemale, profMale, totalForRecord });
  //     return sum + totalForRecord;
  //   }, 0);
  //   console.log("Total Employees:", total);
  //   return total;
  // }, [investorActivityInPark]);
// ==================== FIXED: Total Employees using the 'employment' column ====================
const totalEmployees = useMemo(() => {
  if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) {
    console.log("No investor activity data available for employees");
    return 0;
  }
  
  // Create a Map to store the latest record for each investor_id
  const latestRecordsMap = new Map();
  
  investorActivityInPark.forEach(record => {
    const investorId = record.investor_id;
    // Use activity_period_to for comparison (most recent period)
    const currentDate = new Date(record.activity_period_to || record.recorded_on);
    
    if (!latestRecordsMap.has(investorId)) {
      latestRecordsMap.set(investorId, record);
    } else {
      const existingRecord = latestRecordsMap.get(investorId);
      const existingDate = new Date(existingRecord.activity_period_to || existingRecord.recorded_on);
      
      if (currentDate > existingDate) {
        latestRecordsMap.set(investorId, record);
      }
    }
  });
  
  // Get the latest records
  const latestRecords = Array.from(latestRecordsMap.values());
  console.log("Latest records per investor:", latestRecords);
  
  // ✅ FIX: Use the 'employment' column directly, not sum of individual fields
  const total = latestRecords.reduce((sum, e) => {
    const employmentValue = toNumber(e.employment);
    console.log(`Investor ${e.investor_id}: employment = ${employmentValue}`);
    return sum + employmentValue;
  }, 0);
  
  console.log("Total Employees (using employment column):", total);
  return total;
}, [investorActivityInPark]);
  // ==================== FIXED: Total Import (Import Substitution) ====================
  const totalImport = useMemo(() => {
    if (!investorActivityInPark || !Array.isArray(investorActivityInPark) || investorActivityInPark.length === 0) return 0;
    return investorActivityInPark.reduce((sum, t) => sum + toNumber(t.import_substitution), 0);
  }, [investorActivityInPark]);

  // ==================== FIXED: Total Revenue Calculations ====================
  const totalRevenueUSD = useMemo(() => {
    if (!filteredRevenue || !Array.isArray(filteredRevenue) || filteredRevenue.length === 0) return 0;
    return filteredRevenue
      .filter(r => normalizeCurrency(r.payment_mode) === "usd")
      .reduce((sum, r) => sum + toNumber(r.amount), 0);
  }, [filteredRevenue]);

  const totalRevenueBirr = useMemo(() => {
    if (!filteredRevenue || !Array.isArray(filteredRevenue) || filteredRevenue.length === 0) return 0;
    return filteredRevenue
      .filter(r => normalizeCurrency(r.payment_mode) === "birr")
      .reduce((sum, r) => sum + toNumber(r.amount), 0);
  }, [filteredRevenue]);

  // ==================== FIXED: Total Outstanding Calculations ====================
  const totalOutstandingUSD = useMemo(() => {
    if (!filteredArrears || !Array.isArray(filteredArrears) || filteredArrears.length === 0) return 0;
    return filteredArrears
      .filter(a => normalizeCurrency(a.payment_mode) === "usd")
      .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
  }, [filteredArrears]);

  const totalOutstandingBirr = useMemo(() => {
    if (!filteredArrears || !Array.isArray(filteredArrears) || filteredArrears.length === 0) return 0;
    return filteredArrears
      .filter(a => normalizeCurrency(a.payment_mode) === "birr")
      .reduce((sum, a) => sum + toNumber(a.outstanding), 0);
  }, [filteredArrears]);

  // ==================== FIXED: Park Summary ====================
  const parkSummary = useMemo(() => {
    const safeShedsData = Array.isArray(shedsData) ? shedsData : [];
    const safeParcelsData = Array.isArray(parcelsData) ? parcelsData : [];
    
    const parkParcels = safeParcelsData.filter(p => String(p.park_id) === String(parkIdin));
    const occupiedParcels = parkParcels.filter(p => p.rental_lease_status === "Occupied").length;
    
    let totalParcelArea = 0;
    if (safeParcelsData.length > 0) {
      console.log("Park ID from user:", parkIdin);
      console.log("Total parcels in park:", parkParcels.length);
      totalParcelArea = parkParcels.reduce((sum, p) => sum + (p.area || 0), 0);
      console.log("Total area:", totalParcelArea);
    }
    
    const occupiedArea = parkParcels.filter(p => p.rental_lease_status === "Occupied").reduce((sum, p) => sum + (p.area || 0), 0);
    
    const parkSheds = safeShedsData.filter(s => String(s.park_id) === String(parkIdin));
    const occupiedSheds = safeShedsData.filter(s => s.status_utilization === "Occupied").length;
    console.log("SHEDDDDDDDDDDssss", occupiedSheds);
    
    return {
      occupancyRate: totalParcelArea > 0 ? (occupiedArea / totalParcelArea) * 100 : 0,
      parcelRatio: parkParcels.length > 0 ? (occupiedParcels / parkParcels.length) * 100 : 0,
      shedOccupancy: parkSheds.length > 0 ? (occupiedSheds / parkSheds.length) * 100 : 0,
      totalArea: totalParcelArea,
      occupiedArea,
      totalParcels: parkParcels.length,
      occupiedParcels,
      parkName: ""
    };
  }, [parkIdin, parcelsData, shedsData]);

  // ==================== FIXED: Land Use Data ====================
  const landUseData = useMemo(() => {
    console.log("LandUseInPark data:", landUseInPark);
    
    if (!landUseInPark || !Array.isArray(landUseInPark) || landUseInPark.length === 0) {
      return { 'Parcels': 0, 'Green Areas': 0, 'Roads': 0 };
    }
    
    let totalArea = 0;
    let availableArea = 0;
    let holdArea = 0;
    
    if (Array.isArray(landUseInPark) && landUseInPark.length > 0) {
      totalArea = landUseInPark[0].totalarea || landUseInPark[0].total_area || 0;
      availableArea = landUseInPark[0].availablearea || landUseInPark[0].available_area || 0;
      holdArea = landUseInPark[0].holdarea || landUseInPark[0].hold_area || 0;
    } else if (typeof landUseInPark === 'object' && !Array.isArray(landUseInPark)) {
      totalArea = landUseInPark.totalarea || landUseInPark.total_area || 0;
      availableArea = landUseInPark.availablearea || landUseInPark.available_area || 0;
      holdArea = landUseInPark.holdarea || landUseInPark.hold_area || 0;
    }
    
    console.log("Processed land use data:", { totalArea, availableArea, holdArea });
    
    return { 
      'Total Area': totalArea, 
      'Available Area': availableArea, 
      'Hold Area': holdArea 
    };
  }, [landUseInPark]);

  // ==================== Occupancy Availability Data ====================
  const occupancyData = useMemo(() => {
    console.log("Occupancy Availability Data:", occupavailInPark);
    
    if (!occupavailInPark || !Array.isArray(occupavailInPark) || occupavailInPark.length === 0) {
      return { 'Available': 0, 'Hold': 0 };
    }
    
    let availableArea = 0;
    let holdArea = 0;
    
    if (Array.isArray(occupavailInPark) && occupavailInPark.length > 0) {
      availableArea = occupavailInPark[0].availablearea || occupavailInPark[0].availableArea || 0;
      holdArea = occupavailInPark[0].holdarea || occupavailInPark[0].holdArea || 0;
    } else if (typeof occupavailInPark === 'object' && !Array.isArray(occupavailInPark)) {
      availableArea = occupavailInPark.availablearea || occupavailInPark.availableArea || 0;
      holdArea = occupavailInPark.holdarea || occupavailInPark.holdArea || 0;
    }
    
    return { 'Available': availableArea, 'Hold': holdArea };
  }, [occupavailInPark]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress /><Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: '#f4f9ff', width: '100%', mx: 0, py: 1 }}>
      {/* Header */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
            <Grid item xs={12} md={12}>
              <IPDCWelcomeMessage messageTitle="Park Staff" />
            </Grid>
          </Typography>
        </Box>
      </Container>

      {/* Bold Line Separator */}
      <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>

      {/* ========== SECTION 2: KEY METRICS ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <AssessmentIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Key Performance Metrics</Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Occupancy Rate</Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.occupancyRate)}</Typography>
              <ProgressBarCell value={parkSummary.occupancyRate} label="Occupancy" />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Shed Occupancy</Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(parkSummary.shedOccupancy)}</Typography>
              <ProgressBarCell value={parkSummary.shedOccupancy} label="Shed" color="#795548" />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', textAlign: 'center' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Area</Typography>
              <Typography variant="h5" fontWeight="bold">{parkSummary.totalArea.toFixed(1)} m²</Typography>
              <Typography variant="caption" color="textSecondary">Occupied: {parkSummary.occupiedArea.toFixed(1)}m²</Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Bold Line Separator */}
      <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>

      {/* ========== SECTION 3: REPORTS ROW 1 ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <QuarterlyReportCard revenueData={filteredRevenue} arrearsData={filteredArrears} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InvestorSummaryCard investorsData={filteredInvestors} potentialInvestors={[]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InvestmentByIndustryCard investorsData={filteredInvestors} />
          </Grid>
        </Grid>
      </Container>

      {/* Bold Line Separator */}
      <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>

      {/* ========== SECTION 5: FINANCIAL ANALYTICS ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <BarChartIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Investor Activities</Typography>
        </Box>

        {/* KPI Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Revenue</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
                <Box>
                  <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
                  <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
                    {formatCurrencyUSD(totalRevenueUSD)}
                  </Typography>
                </Box>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                <Box>
                  <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
                  <Typography sx={{ fontSize: '0.8rem', color: '#2e7d32' }}>
                    {formatCurrencyETB(totalRevenueBirr)}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Outstanding</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: 1, flex: 1 }}>
                <Box>
                  <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#1976d2' }}>USD</Typography>
                  <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
                    {formatCurrencyUSD(totalOutstandingUSD)}
                  </Typography>
                </Box>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                <Box>
                  <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#ff9800' }}>BIRR</Typography>
                  <Typography sx={{ fontSize: '0.8rem', color: '#d32f2f' }}>
                    {formatCurrencyETB(totalOutstandingBirr)}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Export</Typography>
              <Typography variant="h6" fontWeight="bold" color="#1976d2" sx={{ mt: 1 }}>
                {formatCurrencyUSD(totalExport)}
              </Typography>
            </Card>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}>Total Employees</Typography>
              <Typography variant="h6" fontWeight="bold" sx={{ mt: 1 }}>
                {formatNumber(totalEmployees)}
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Bold Line Separator */}
      <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>

      {/* ========== SECTION 6: LAND USE & INVESTMENT ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 }, mb: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
              <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
                Land Use Proportion
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                <Box sx={{ position: 'relative', width: 180, height: 180 }}>
                  <svg width={180} height={180} viewBox="0 0 180 180">
                    {(() => {
                      const items = Object.keys(landUseData);
                      const total = items.reduce((sum, key) => sum + landUseData[key], 0);
                      const colors = ['#1976d2', '#4caf50', '#ff9800'];
                      let startAngle = 0;
                      const centerX = 90, centerY = 90, radius = 70;
                      if (total === 0) {
                        return <text x={90} y={90} textAnchor="middle" fontSize="4" fill="#999">No data available</text>;
                      }
                      return items.map((key, index) => {
                        const value = landUseData[key];
                        const percentage = total > 0 ? (value / total) * 100 : 0;
                        const angle = (percentage / 100) * 360;
                        const endAngle = startAngle + angle;
                        const startRad = (startAngle * Math.PI) / 180;
                        const endRad = (endAngle * Math.PI) / 180;
                        const x1 = centerX + radius * Math.cos(startRad);
                        const y1 = centerY + radius * Math.sin(startRad);
                        const x2 = centerX + radius * Math.cos(endRad);
                        const y2 = centerY + radius * Math.sin(endRad);
                        const largeArcFlag = angle > 180 ? 1 : 0;
                        const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
                        startAngle = endAngle;
                        return <path key={key} d={pathData} fill={colors[index]} stroke="white" strokeWidth="2" />;
                      });
                    })()}
                    <circle cx={90} cy={90} r="35" fill="white" />
                    <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
                    <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
                      {formatNumber(Object.values(landUseData).reduce((a, b) => a + b, 0))} m²
                    </text>
                  </svg>
                </Box>
                <Box>
                  {Object.entries(landUseData).map(([key, value], idx) => {
                    const total = Object.values(landUseData).reduce((a, b) => a + b, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                    const colors = ['#1976d2', '#4caf50', '#ff9800'];
                    return (
                      <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Box sx={{ width: 12, height: 12, bgcolor: colors[idx], borderRadius: 1 }} />
                        <Typography variant="caption">
                          {key}: {value.toFixed(1)} m² ({percentage}%)
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Grid>
          
          {/* Land Occupancy Status Chart */}
          <Grid item xs={12} md={6}>
            <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
              <Typography variant="subtitle1" sx={{ fontSize: '1.2rem', mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
                Land Occupancy Status
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                <Box sx={{ position: 'relative', width: 180, height: 180 }}>
                  <svg width={180} height={180} viewBox="0 0 180 180">
                    {(() => {
                      const items = Object.keys(occupancyData);
                      const total = items.reduce((sum, key) => sum + occupancyData[key], 0);
                      const colors = ['#4caf50', '#ff9800', '#f44336'];
                      let startAngle = 0;
                      const centerX = 90, centerY = 90, radius = 70;
                      
                      if (items.length === 0 || total === 0) {
                        // return <text x={90} y={90} textAnchor="middle" fontSize="4" fill="#999">No data available</text>;
                        return <text x={90} y={90} textAnchor="middle" fontSize="4" fill="#999"></text>;
                      }
                      
                      return items.map((key, index) => {
                        const value = occupancyData[key];
                        const percentage = total > 0 ? (value / total) * 100 : 0;
                        const angle = (percentage / 100) * 360;
                        const endAngle = startAngle + angle;
                        const startRad = (startAngle * Math.PI) / 180;
                        const endRad = (endAngle * Math.PI) / 180;
                        const x1 = centerX + radius * Math.cos(startRad);
                        const y1 = centerY + radius * Math.sin(startRad);
                        const x2 = centerX + radius * Math.cos(endRad);
                        const y2 = centerY + radius * Math.sin(endRad);
                        const largeArcFlag = angle > 180 ? 1 : 0;
                        const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
                        startAngle = endAngle;
                        return <path key={key} d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="2" />;
                      });
                    })()}
                    <circle cx={90} cy={90} r="35" fill="white" />
                    <text x={90} y={85} textAnchor="middle" fontSize="2" fill="#666">Total</text>
                    <text x={90} y={96} textAnchor="middle" fontSize="2" fill="#1976d2">
                      {formatNumber(Object.values(occupancyData).reduce((a, b) => a + b, 0))} m²
                    </text>
                  </svg>
                </Box>
                <Box>
                  {Object.entries(occupancyData).map(([key, value], idx) => {
                    const total = Object.values(occupancyData).reduce((a, b) => a + b, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                    const colors = ['#4caf50', '#ff9800', '#f44336'];
                    return (
                      <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Box sx={{ width: 12, height: 12, bgcolor: colors[idx % colors.length], borderRadius: 1 }} />
                        <Typography variant="caption">
                          {key}: {value.toFixed(1)} m² ({percentage}%)
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Bold Line Separator */}
      <Container maxWidth="xl" sx={{ my: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>
    </Box>
  );
}

